export default {
  "colors": [
    {
      "name": "Label/Light/Primary",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Secondary",
      "values": {
        "hex": "#000004",
        "hexa": "#000004d9",
        "rgb": "rgb(0, 0, 4)",
        "rgba": "rgba(0, 0, 4, 0.85)",
        "hsl": "hsl(240, 100%, 1%)",
        "hsla": "hsl(240, 100%, 1%, 0.85)",
        "alpha": 0.85
      }
    },
    {
      "name": "Label/Light/Tertiary",
      "values": {
        "hex": "#000008",
        "hexa": "#00000878",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.47)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.47)",
        "alpha": 0.47
      }
    },
    {
      "name": "Label/Light/Quaternary",
      "values": {
        "hex": "#000008",
        "hexa": "#00000861",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.38)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.38)",
        "alpha": 0.38
      }
    },
    {
      "name": "Label/Light/Quinary",
      "values": {
        "hex": "#000008",
        "hexa": "#00000833",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.2)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Label/Light/AlwaysDark Primary",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/AlwaysLight Primary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/AlwaysLight Secondary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFb3",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.7)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Label/Light/Always Light Tertiary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF66",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.4)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "Label/Light/Inverted",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Inverted Secondary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF80",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.5)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Label/Light/Error",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 82%, 58%)",
        "hsla": "hsl(5, 82%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Favorite",
      "values": {
        "hex": "#FFD60A",
        "hexa": "#FFD60Aff",
        "rgb": "rgb(255, 214, 10)",
        "rgba": "rgba(255, 214, 10, 1)",
        "hsl": "hsl(50, 100%, 52%)",
        "hsla": "hsl(50, 100%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/AlwaysDark Secondary",
      "values": {
        "hex": "#000000",
        "hexa": "#000000b3",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.7)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Label/Light/Selected",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Unselected",
      "values": {
        "hex": "#87878B",
        "hexa": "#87878Bff",
        "rgb": "rgb(135, 135, 139)",
        "rgba": "rgba(135, 135, 139, 1)",
        "hsl": "hsl(240, 2%, 54%)",
        "hsla": "hsl(240, 2%, 54%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Inverted Hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF80",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.5)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Label/Light/Warning",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 82%, 58%)",
        "hsla": "hsl(5, 82%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Logo color",
      "values": {
        "hex": "#E51D73",
        "hexa": "#E51D73ff",
        "rgb": "rgb(229, 29, 115)",
        "rgba": "rgba(229, 29, 115, 1)",
        "hsl": "hsl(334, 79%, 51%)",
        "hsla": "hsl(334, 79%, 51%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Unselected Web",
      "values": {
        "hex": "#D6D6D6",
        "hexa": "#D6D6D6ff",
        "rgb": "rgb(214, 214, 214)",
        "rgba": "rgba(214, 214, 214, 1)",
        "hsl": "hsl(0, 0%, 84%)",
        "hsla": "hsl(0, 0%, 84%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Unselected App",
      "values": {
        "hex": "#949697",
        "hexa": "#949697ff",
        "rgb": "rgb(148, 150, 151)",
        "rgba": "rgba(148, 150, 151, 1)",
        "hsl": "hsl(200, 1%, 59%)",
        "hsla": "hsl(200, 1%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Production Information Missing",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 82%, 58%)",
        "hsla": "hsl(5, 82%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/TV Primary",
      "values": {
        "hex": "#41416D",
        "hexa": "#41416Dff",
        "rgb": "rgb(65, 65, 109)",
        "rgba": "rgba(65, 65, 109, 1)",
        "hsl": "hsl(240, 25%, 34%)",
        "hsla": "hsl(240, 25%, 34%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/TV Secondary",
      "values": {
        "hex": "#5C5C80",
        "hexa": "#5C5C80b3",
        "rgb": "rgb(92, 92, 128)",
        "rgba": "rgba(92, 92, 128, 0.7)",
        "hsl": "hsl(240, 16%, 43%)",
        "hsla": "hsl(240, 16%, 43%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Label/Light/Unselected Web Hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Light/Unselected Web Pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF4d",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.3)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Label/Light/Always Light Quaternary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Label/Dark/Primary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Secondary",
      "values": {
        "hex": "#FAFAFF",
        "hexa": "#FAFAFFd9",
        "rgb": "rgb(250, 250, 255)",
        "rgba": "rgba(250, 250, 255, 0.85)",
        "hsl": "hsl(240, 100%, 99%)",
        "hsla": "hsl(240, 100%, 99%, 0.85)",
        "alpha": 0.85
      }
    },
    {
      "name": "Label/Dark/Tertiary",
      "values": {
        "hex": "#FAFAFF",
        "hexa": "#FAFAFF8a",
        "rgb": "rgb(250, 250, 255)",
        "rgba": "rgba(250, 250, 255, 0.54)",
        "hsl": "hsl(240, 100%, 99%)",
        "hsla": "hsl(240, 100%, 99%, 0.54)",
        "alpha": 0.54
      }
    },
    {
      "name": "Label/Dark/Quaternary",
      "values": {
        "hex": "#FAFAFF",
        "hexa": "#FAFAFF66",
        "rgb": "rgb(250, 250, 255)",
        "rgba": "rgba(250, 250, 255, 0.4)",
        "hsl": "hsl(240, 100%, 99%)",
        "hsla": "hsl(240, 100%, 99%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "Label/Dark/Quinary",
      "values": {
        "hex": "#FAFAFF",
        "hexa": "#FAFAFF33",
        "rgb": "rgb(250, 250, 255)",
        "rgba": "rgba(250, 250, 255, 0.2)",
        "hsl": "hsl(240, 100%, 99%)",
        "hsla": "hsl(240, 100%, 99%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Label/Dark/AlwaysDark Primary",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/AlwaysLight Primary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/AlwaysLight Secondary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF80",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.5)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Label/Dark/Always Light Tertiary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF59",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.35)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.35)",
        "alpha": 0.35
      }
    },
    {
      "name": "Label/Dark/Inverted",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Inverted Secondary",
      "values": {
        "hex": "#000000",
        "hexa": "#00000080",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.5)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Label/Dark/Error",
      "values": {
        "hex": "#D24E47",
        "hexa": "#D24E47ff",
        "rgb": "rgb(210, 78, 71)",
        "rgba": "rgba(210, 78, 71, 1)",
        "hsl": "hsl(3, 61%, 55%)",
        "hsla": "hsl(3, 61%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Favorite",
      "values": {
        "hex": "#FFD60A",
        "hexa": "#FFD60Aff",
        "rgb": "rgb(255, 214, 10)",
        "rgba": "rgba(255, 214, 10, 1)",
        "hsl": "hsl(50, 100%, 52%)",
        "hsla": "hsl(50, 100%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/AlwaysDark Secondary",
      "values": {
        "hex": "#000000",
        "hexa": "#000000b3",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.7)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Label/Dark/Selected",
      "values": {
        "hex": "#FFF9BE",
        "hexa": "#FFF9BEff",
        "rgb": "rgb(255, 249, 190)",
        "rgba": "rgba(255, 249, 190, 1)",
        "hsl": "hsl(54, 100%, 87%)",
        "hsla": "hsl(54, 100%, 87%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Unselected",
      "values": {
        "hex": "#B4B4B4",
        "hexa": "#B4B4B4ff",
        "rgb": "rgb(180, 180, 180)",
        "rgba": "rgba(180, 180, 180, 1)",
        "hsl": "hsl(0, 0%, 71%)",
        "hsla": "hsl(0, 0%, 71%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Inverted Hover",
      "values": {
        "hex": "#000000",
        "hexa": "#00000080",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.5)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Label/Dark/Warning",
      "values": {
        "hex": "#D24E47",
        "hexa": "#D24E47ff",
        "rgb": "rgb(210, 78, 71)",
        "rgba": "rgba(210, 78, 71, 1)",
        "hsl": "hsl(3, 61%, 55%)",
        "hsla": "hsl(3, 61%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Logo color",
      "values": {
        "hex": "#F04A90",
        "hexa": "#F04A90ff",
        "rgb": "rgb(240, 74, 144)",
        "rgba": "rgba(240, 74, 144, 1)",
        "hsl": "hsl(335, 85%, 62%)",
        "hsla": "hsl(335, 85%, 62%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Unselected Web",
      "values": {
        "hex": "#B4B4B4",
        "hexa": "#B4B4B4ff",
        "rgb": "rgb(180, 180, 180)",
        "rgba": "rgba(180, 180, 180, 1)",
        "hsl": "hsl(0, 0%, 71%)",
        "hsla": "hsl(0, 0%, 71%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Unselected App",
      "values": {
        "hex": "#7F8081",
        "hexa": "#7F8081ff",
        "rgb": "rgb(127, 128, 129)",
        "rgba": "rgba(127, 128, 129, 1)",
        "hsl": "hsl(210, 1%, 50%)",
        "hsla": "hsl(210, 1%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Production Information Missing",
      "values": {
        "hex": "#D24E47",
        "hexa": "#D24E47ff",
        "rgb": "rgb(210, 78, 71)",
        "rgba": "rgba(210, 78, 71, 1)",
        "hsl": "hsl(3, 61%, 55%)",
        "hsla": "hsl(3, 61%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/TV Primary",
      "values": {
        "hex": "#E8EAED",
        "hexa": "#E8EAEDff",
        "rgb": "rgb(232, 234, 237)",
        "rgba": "rgba(232, 234, 237, 1)",
        "hsl": "hsl(216, 12%, 92%)",
        "hsla": "hsl(216, 12%, 92%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/TV Secondary",
      "values": {
        "hex": "#E8EAED",
        "hexa": "#E8EAEDb3",
        "rgb": "rgb(232, 234, 237)",
        "rgba": "rgba(232, 234, 237, 0.7)",
        "hsl": "hsl(216, 12%, 92%)",
        "hsla": "hsl(216, 12%, 92%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Label/Dark/Unselected Web Hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Label/Dark/Unselected Web Pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Label/Dark/Always Light Quaternary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF2e",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.18)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.18)",
        "alpha": 0.18
      }
    },
    {
      "name": "Background/Light/System [mobile]",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/System [web]",
      "values": {
        "hex": "#FAFAFA",
        "hexa": "#FAFAFAff",
        "rgb": "rgb(250, 250, 250)",
        "rgba": "rgba(250, 250, 250, 1)",
        "hsl": "hsl(0, 0%, 98%)",
        "hsla": "hsl(0, 0%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Detail [mobile]",
      "values": {
        "hex": "#F2F2F7",
        "hexa": "#F2F2F7ff",
        "rgb": "rgb(242, 242, 247)",
        "rgba": "rgba(242, 242, 247, 1)",
        "hsl": "hsl(240, 24%, 96%)",
        "hsla": "hsl(240, 24%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Detail [web]",
      "values": {
        "hex": "#FAFAFA",
        "hexa": "#FAFAFAff",
        "rgb": "rgb(250, 250, 250)",
        "rgba": "rgba(250, 250, 250, 1)",
        "hsl": "hsl(0, 0%, 98%)",
        "hsla": "hsl(0, 0%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Panel [mobile]",
      "values": {
        "hex": "#F2F2F7",
        "hexa": "#F2F2F7ff",
        "rgb": "rgb(242, 242, 247)",
        "rgba": "rgba(242, 242, 247, 1)",
        "hsl": "hsl(240, 24%, 96%)",
        "hsla": "hsl(240, 24%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Panel [web]",
      "values": {
        "hex": "#FAFAFA",
        "hexa": "#FAFAFAff",
        "rgb": "rgb(250, 250, 250)",
        "rgba": "rgba(250, 250, 250, 1)",
        "hsl": "hsl(0, 0%, 98%)",
        "hsla": "hsl(0, 0%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field [mobile]",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on Panel [mobile]",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field [web]",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on Panel [web]",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field lighter",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on modal",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field [web] hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000005",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.02)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.02)",
        "alpha": 0.02
      }
    },
    {
      "name": "Background/Light/Field [mobile] hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000005",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.02)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.02)",
        "alpha": 0.02
      }
    },
    {
      "name": "Background/Light/Field on Panel [mobile] hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000005",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.02)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.02)",
        "alpha": 0.02
      }
    },
    {
      "name": "Background/Light/Field on Panel [web] hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000005",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.02)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.02)",
        "alpha": 0.02
      }
    },
    {
      "name": "Background/Light/Field [web] pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#000000d",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.05)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.05)",
        "alpha": 0.05
      }
    },
    {
      "name": "Background/Light/Field [mobile] pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#000000d",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.05)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.05)",
        "alpha": 0.05
      }
    },
    {
      "name": "Background/Light/Field on Panel [mobile] pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#0000008",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.03)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.03)",
        "alpha": 0.03
      }
    },
    {
      "name": "Background/Light/Field on Panel [web] pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#0000008",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.03)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.03)",
        "alpha": 0.03
      }
    },
    {
      "name": "Background/Light/Field on submenu",
      "values": {
        "hex": "#FAFAFA",
        "hexa": "#FAFAFAff",
        "rgb": "rgb(250, 250, 250)",
        "rgba": "rgba(250, 250, 250, 1)",
        "hsl": "hsl(0, 0%, 98%)",
        "hsla": "hsl(0, 0%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on submenu hover",
      "values": {
        "hex": "#FAFAFA",
        "hexa": "#FAFAFAff",
        "rgb": "rgb(250, 250, 250)",
        "rgba": "rgba(250, 250, 250, 1)",
        "hsl": "hsl(0, 0%, 98%)",
        "hsla": "hsl(0, 0%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on submenu pressed",
      "values": {
        "hex": "#F2F2F2",
        "hexa": "#F2F2F2ff",
        "rgb": "rgb(242, 242, 242)",
        "rgba": "rgba(242, 242, 242, 1)",
        "hsl": "hsl(0, 0%, 95%)",
        "hsla": "hsl(0, 0%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Picture Underlay",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/menuApp",
      "values": {
        "hex": "#F6F6F6",
        "hexa": "#F6F6F6ff",
        "rgb": "rgb(246, 246, 246)",
        "rgba": "rgba(246, 246, 246, 1)",
        "hsl": "hsl(0, 0%, 96%)",
        "hsla": "hsl(0, 0%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/menuWeb",
      "values": {
        "hex": "#333333",
        "hexa": "#333333ff",
        "rgb": "rgb(51, 51, 51)",
        "rgba": "rgba(51, 51, 51, 1)",
        "hsl": "hsl(0, 0%, 20%)",
        "hsla": "hsl(0, 0%, 20%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Modal",
      "values": {
        "hex": "#F2F2F7",
        "hexa": "#F2F2F7ff",
        "rgb": "rgb(242, 242, 247)",
        "rgba": "rgba(242, 242, 247, 1)",
        "hsl": "hsl(240, 24%, 96%)",
        "hsla": "hsl(240, 24%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/New flag",
      "values": {
        "hex": "#FFCD29",
        "hexa": "#FFCD29ff",
        "rgb": "rgb(255, 205, 41)",
        "rgba": "rgba(255, 205, 41, 1)",
        "hsl": "hsl(46, 100%, 58%)",
        "hsla": "hsl(46, 100%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Wallboard Tile Screen",
      "values": {
        "hex": "#D8D9DA",
        "hexa": "#D8D9DAff",
        "rgb": "rgb(216, 217, 218)",
        "rgba": "rgba(216, 217, 218, 1)",
        "hsl": "hsl(210, 3%, 85%)",
        "hsla": "hsl(210, 3%, 85%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Wallboard",
      "values": {
        "hex": "#CFDBEB",
        "hexa": "#CFDBEBff",
        "rgb": "rgb(207, 219, 235)",
        "rgba": "rgba(207, 219, 235, 1)",
        "hsl": "hsl(214, 41%, 87%)",
        "hsla": "hsl(214, 41%, 87%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Header App",
      "values": {
        "hex": "#FEFEFE",
        "hexa": "#FEFEFEff",
        "rgb": "rgb(254, 254, 254)",
        "rgba": "rgba(254, 254, 254, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/menuWeb pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Background/Light/Chart",
      "values": {
        "hex": "#000000",
        "hexa": "#00000014",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.08)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.08)",
        "alpha": 0.08
      }
    },
    {
      "name": "Background/Light/menuWeb hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1a",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Background/Light/Button background on image",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Background/Light/Keyboard",
      "values": {
        "hex": "#D4D6DC",
        "hexa": "#D4D6DCff",
        "rgb": "rgb(212, 214, 220)",
        "rgba": "rgba(212, 214, 220, 1)",
        "hsl": "hsl(225, 10%, 85%)",
        "hsla": "hsl(225, 10%, 85%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Modal Highlight",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Clocked In",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Clocked Out",
      "values": {
        "hex": "#F8F9FB",
        "hexa": "#F8F9FBff",
        "rgb": "rgb(248, 249, 251)",
        "rgba": "rgba(248, 249, 251, 1)",
        "hsl": "hsl(220, 27%, 98%)",
        "hsla": "hsl(220, 27%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Event",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Warning",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 82%, 58%)",
        "hsla": "hsl(5, 82%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Corporate Web",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Secondary on detail [mobile]",
      "values": {
        "hex": "#E9E8EE",
        "hexa": "#E9E8EEff",
        "rgb": "rgb(233, 232, 238)",
        "rgba": "rgba(233, 232, 238, 1)",
        "hsl": "hsl(250, 15%, 92%)",
        "hsla": "hsl(250, 15%, 92%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Secondary on detail [web]",
      "values": {
        "hex": "#F1F1F1",
        "hexa": "#F1F1F1ff",
        "rgb": "rgb(241, 241, 241)",
        "rgba": "rgba(241, 241, 241, 1)",
        "hsl": "hsl(0, 0%, 95%)",
        "hsla": "hsl(0, 0%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Submenu",
      "values": {
        "hex": "#E1E1E1",
        "hexa": "#E1E1E1ff",
        "rgb": "rgb(225, 225, 225)",
        "rgba": "rgba(225, 225, 225, 1)",
        "hsl": "hsl(0, 0%, 88%)",
        "hsla": "hsl(0, 0%, 88%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Production Information Missing",
      "values": {
        "hex": "#FFDA15",
        "hexa": "#FFDA15ff",
        "rgb": "rgb(255, 218, 21)",
        "rgba": "rgba(255, 218, 21, 1)",
        "hsl": "hsl(51, 100%, 54%)",
        "hsla": "hsl(51, 100%, 54%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Timeline",
      "values": {
        "hex": "#E1E1E1",
        "hexa": "#E1E1E1ff",
        "rgb": "rgb(225, 225, 225)",
        "rgba": "rgba(225, 225, 225, 1)",
        "hsl": "hsl(0, 0%, 88%)",
        "hsla": "hsl(0, 0%, 88%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/System [web] hover",
      "values": {
        "hex": "#EEEEEE",
        "hexa": "#EEEEEEff",
        "rgb": "rgb(238, 238, 238)",
        "rgba": "rgba(238, 238, 238, 1)",
        "hsl": "hsl(0, 0%, 93%)",
        "hsla": "hsl(0, 0%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/System [web] pressed",
      "values": {
        "hex": "#E6E6E6",
        "hexa": "#E6E6E6ff",
        "rgb": "rgb(230, 230, 230)",
        "rgba": "rgba(230, 230, 230, 1)",
        "hsl": "hsl(0, 0%, 90%)",
        "hsla": "hsl(0, 0%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/menuWeb selector",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF12",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.07)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.07)",
        "alpha": 0.07
      }
    },
    {
      "name": "Background/Light/Search & View Selector",
      "values": {
        "hex": "#2F2F34",
        "hexa": "#2F2F3414",
        "rgb": "rgb(47, 47, 52)",
        "rgba": "rgba(47, 47, 52, 0.08)",
        "hsl": "hsl(240, 5%, 19%)",
        "hsla": "hsl(240, 5%, 19%, 0.08)",
        "alpha": 0.08
      }
    },
    {
      "name": "Background/Light/Segmented Control",
      "values": {
        "hex": "#030308",
        "hexa": "#03030812",
        "rgb": "rgb(3, 3, 8)",
        "rgba": "rgba(3, 3, 8, 0.07)",
        "hsl": "hsl(240, 45%, 2%)",
        "hsla": "hsl(240, 45%, 2%, 0.07)",
        "alpha": 0.07
      }
    },
    {
      "name": "Background/Light/Panel background op top",
      "values": {
        "hex": "#C4C4C4",
        "hexa": "#C4C4C4ff",
        "rgb": "rgb(196, 196, 196)",
        "rgba": "rgba(196, 196, 196, 1)",
        "hsl": "hsl(0, 0%, 77%)",
        "hsla": "hsl(0, 0%, 77%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Tile No Picture",
      "values": {
        "hex": "#EAEAEF",
        "hexa": "#EAEAEFff",
        "rgb": "rgb(234, 234, 239)",
        "rgba": "rgba(234, 234, 239, 1)",
        "hsl": "hsl(240, 14%, 93%)",
        "hsla": "hsl(240, 14%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/App Logo",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Kiosk Primary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Kiosk Secondary",
      "values": {
        "hex": "#F3F2F8",
        "hexa": "#F3F2F8ff",
        "rgb": "rgb(243, 242, 248)",
        "rgba": "rgba(243, 242, 248, 1)",
        "hsl": "hsl(250, 30%, 96%)",
        "hsla": "hsl(250, 30%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Panel Left Pane [mobile]",
      "values": {
        "hex": "#F2F2F7",
        "hexa": "#F2F2F7ff",
        "rgb": "rgb(242, 242, 247)",
        "rgba": "rgba(242, 242, 247, 1)",
        "hsl": "hsl(240, 24%, 96%)",
        "hsla": "hsl(240, 24%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Panel Left Pane [web]",
      "values": {
        "hex": "#FAFAFA",
        "hexa": "#FAFAFAff",
        "rgb": "rgb(250, 250, 250)",
        "rgba": "rgba(250, 250, 250, 1)",
        "hsl": "hsl(0, 0%, 98%)",
        "hsla": "hsl(0, 0%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Status Bar",
      "values": {
        "hex": "#B4B4B4",
        "hexa": "#B4B4B4ff",
        "rgb": "rgb(180, 180, 180)",
        "rgba": "rgba(180, 180, 180, 1)",
        "hsl": "hsl(0, 0%, 71%)",
        "hsla": "hsl(0, 0%, 71%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on modal highlight",
      "values": {
        "hex": "#F4F4F4",
        "hexa": "#F4F4F4ff",
        "rgb": "rgb(244, 244, 244)",
        "rgba": "rgba(244, 244, 244, 1)",
        "hsl": "hsl(0, 0%, 96%)",
        "hsla": "hsl(0, 0%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on modal hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000005",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.02)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.02)",
        "alpha": 0.02
      }
    },
    {
      "name": "Background/Light/Field on modal pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#0000008",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.03)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.03)",
        "alpha": 0.03
      }
    },
    {
      "name": "Background/Light/Field on modal highlight pressed",
      "values": {
        "hex": "#ECECEC",
        "hexa": "#ECECECff",
        "rgb": "rgb(236, 236, 236)",
        "rgba": "rgba(236, 236, 236, 1)",
        "hsl": "hsl(0, 0%, 93%)",
        "hsla": "hsl(0, 0%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field on modal highlight hover",
      "values": {
        "hex": "#F0F0F0",
        "hexa": "#F0F0F0ff",
        "rgb": "rgb(240, 240, 240)",
        "rgba": "rgba(240, 240, 240, 1)",
        "hsl": "hsl(0, 0%, 94%)",
        "hsla": "hsl(0, 0%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field very light",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Field very light hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000005",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.02)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.02)",
        "alpha": 0.02
      }
    },
    {
      "name": "Background/Light/Field very light pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#000000d",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.05)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.05)",
        "alpha": 0.05
      }
    },
    {
      "name": "Background/Light/Button background on image black text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF99",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.6)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Background/Light/Chart No Trans",
      "values": {
        "hex": "#EBEBEB",
        "hexa": "#EBEBEBff",
        "rgb": "rgb(235, 235, 235)",
        "rgba": "rgba(235, 235, 235, 1)",
        "hsl": "hsl(0, 0%, 92%)",
        "hsla": "hsl(0, 0%, 92%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Event Grouped",
      "values": {
        "hex": "#E0EEFF",
        "hexa": "#E0EEFFff",
        "rgb": "rgb(224, 238, 255)",
        "rgba": "rgba(224, 238, 255, 1)",
        "hsl": "hsl(213, 100%, 94%)",
        "hsla": "hsl(213, 100%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Event Trace",
      "values": {
        "hex": "#F2F8FF",
        "hexa": "#F2F8FFff",
        "rgb": "rgb(242, 248, 255)",
        "rgba": "rgba(242, 248, 255, 1)",
        "hsl": "hsl(212, 100%, 97%)",
        "hsla": "hsl(212, 100%, 97%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Planboard - Behind",
      "values": {
        "hex": "#FCF3F2",
        "hexa": "#FCF3F2ff",
        "rgb": "rgb(252, 243, 242)",
        "rgba": "rgba(252, 243, 242, 1)",
        "hsl": "hsl(6, 63%, 97%)",
        "hsla": "hsl(6, 63%, 97%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Planboard - Ahead",
      "values": {
        "hex": "#F4F6FF",
        "hexa": "#F4F6FFff",
        "rgb": "rgb(244, 246, 255)",
        "rgba": "rgba(244, 246, 255, 1)",
        "hsl": "hsl(229, 100%, 98%)",
        "hsla": "hsl(229, 100%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Light/Planboard - Waiting",
      "values": {
        "hex": "#FFFBED",
        "hexa": "#FFFBEDff",
        "rgb": "rgb(255, 251, 237)",
        "rgba": "rgba(255, 251, 237, 1)",
        "hsl": "hsl(47, 100%, 96%)",
        "hsla": "hsl(47, 100%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/System [mobile]",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/System [web]",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Detail [mobile]",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Detail [web]",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Panel [mobile]",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Panel [web]",
      "values": {
        "hex": "#18181A",
        "hexa": "#18181Aff",
        "rgb": "rgb(24, 24, 26)",
        "rgba": "rgba(24, 24, 26, 1)",
        "hsl": "hsl(240, 4%, 10%)",
        "hsla": "hsl(240, 4%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Picture Underlay",
      "values": {
        "hex": "#2C2C2E",
        "hexa": "#2C2C2Eff",
        "rgb": "rgb(44, 44, 46)",
        "rgba": "rgba(44, 44, 46, 1)",
        "hsl": "hsl(240, 2%, 18%)",
        "hsla": "hsl(240, 2%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field [mobile]",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field [mobile] hover",
      "values": {
        "hex": "#262628",
        "hexa": "#262628ff",
        "rgb": "rgb(38, 38, 40)",
        "rgba": "rgba(38, 38, 40, 1)",
        "hsl": "hsl(240, 3%, 15%)",
        "hsla": "hsl(240, 3%, 15%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field [web]",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on Panel [web]",
      "values": {
        "hex": "#2C2C2E",
        "hexa": "#2C2C2Eff",
        "rgb": "rgb(44, 44, 46)",
        "rgba": "rgba(44, 44, 46, 1)",
        "hsl": "hsl(240, 2%, 18%)",
        "hsla": "hsl(240, 2%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field lighter",
      "values": {
        "hex": "#363638",
        "hexa": "#363638ff",
        "rgb": "rgb(54, 54, 56)",
        "rgba": "rgba(54, 54, 56, 1)",
        "hsl": "hsl(240, 2%, 22%)",
        "hsla": "hsl(240, 2%, 22%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on modal",
      "values": {
        "hex": "#323234",
        "hexa": "#323234ff",
        "rgb": "rgb(50, 50, 52)",
        "rgba": "rgba(50, 50, 52, 1)",
        "hsl": "hsl(240, 2%, 20%)",
        "hsla": "hsl(240, 2%, 20%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field [web] hover",
      "values": {
        "hex": "#262628",
        "hexa": "#262628ff",
        "rgb": "rgb(38, 38, 40)",
        "rgba": "rgba(38, 38, 40, 1)",
        "hsl": "hsl(240, 3%, 15%)",
        "hsla": "hsl(240, 3%, 15%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on Panel [mobile]",
      "values": {
        "hex": "#2C2C2E",
        "hexa": "#2C2C2Eff",
        "rgb": "rgb(44, 44, 46)",
        "rgba": "rgba(44, 44, 46, 1)",
        "hsl": "hsl(240, 2%, 18%)",
        "hsla": "hsl(240, 2%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on Panel [mobile] hover",
      "values": {
        "hex": "#303032",
        "hexa": "#303032ff",
        "rgb": "rgb(48, 48, 50)",
        "rgba": "rgba(48, 48, 50, 1)",
        "hsl": "hsl(240, 2%, 19%)",
        "hsla": "hsl(240, 2%, 19%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on Panel [web] hover",
      "values": {
        "hex": "#303032",
        "hexa": "#303032ff",
        "rgb": "rgb(48, 48, 50)",
        "rgba": "rgba(48, 48, 50, 1)",
        "hsl": "hsl(240, 2%, 19%)",
        "hsla": "hsl(240, 2%, 19%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field [mobile] pressed",
      "values": {
        "hex": "#2A2A2C",
        "hexa": "#2A2A2Cff",
        "rgb": "rgb(42, 42, 44)",
        "rgba": "rgba(42, 42, 44, 1)",
        "hsl": "hsl(240, 2%, 17%)",
        "hsla": "hsl(240, 2%, 17%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field [web] pressed",
      "values": {
        "hex": "#2A2A2C",
        "hexa": "#2A2A2Cff",
        "rgb": "rgb(42, 42, 44)",
        "rgba": "rgba(42, 42, 44, 1)",
        "hsl": "hsl(240, 2%, 17%)",
        "hsla": "hsl(240, 2%, 17%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on Panel [mobile] pressed",
      "values": {
        "hex": "#343438",
        "hexa": "#343438ff",
        "rgb": "rgb(52, 52, 56)",
        "rgba": "rgba(52, 52, 56, 1)",
        "hsl": "hsl(240, 4%, 21%)",
        "hsla": "hsl(240, 4%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on Panel [web] pressed",
      "values": {
        "hex": "#343438",
        "hexa": "#343438ff",
        "rgb": "rgb(52, 52, 56)",
        "rgba": "rgba(52, 52, 56, 1)",
        "hsl": "hsl(240, 4%, 21%)",
        "hsla": "hsl(240, 4%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on submenu",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF14",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.08)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.08)",
        "alpha": 0.08
      }
    },
    {
      "name": "Background/Dark/Field on submenu hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1a",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Background/Dark/Field on submenu pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1f",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.12)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.12)",
        "alpha": 0.12
      }
    },
    {
      "name": "Background/Dark/menuApp",
      "values": {
        "hex": "#191919",
        "hexa": "#191919ff",
        "rgb": "rgb(25, 25, 25)",
        "rgba": "rgba(25, 25, 25, 1)",
        "hsl": "hsl(0, 0%, 10%)",
        "hsla": "hsl(0, 0%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/menuWeb",
      "values": {
        "hex": "#303030",
        "hexa": "#303030ff",
        "rgb": "rgb(48, 48, 48)",
        "rgba": "rgba(48, 48, 48, 1)",
        "hsl": "hsl(0, 0%, 19%)",
        "hsla": "hsl(0, 0%, 19%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Modal",
      "values": {
        "hex": "#282829",
        "hexa": "#282829ff",
        "rgb": "rgb(40, 40, 41)",
        "rgba": "rgba(40, 40, 41, 1)",
        "hsl": "hsl(240, 1%, 16%)",
        "hsla": "hsl(240, 1%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/New flag",
      "values": {
        "hex": "#E8BB28",
        "hexa": "#E8BB28ff",
        "rgb": "rgb(232, 187, 40)",
        "rgba": "rgba(232, 187, 40, 1)",
        "hsl": "hsl(46, 81%, 53%)",
        "hsla": "hsl(46, 81%, 53%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Wallboard Tile Screen",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Wallboard",
      "values": {
        "hex": "#20252E",
        "hexa": "#20252Eff",
        "rgb": "rgb(32, 37, 46)",
        "rgba": "rgba(32, 37, 46, 1)",
        "hsl": "hsl(219, 18%, 15%)",
        "hsla": "hsl(219, 18%, 15%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Header App",
      "values": {
        "hex": "#121212",
        "hexa": "#121212ff",
        "rgb": "rgb(18, 18, 18)",
        "rgba": "rgba(18, 18, 18, 1)",
        "hsl": "hsl(0, 0%, 7%)",
        "hsla": "hsl(0, 0%, 7%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/menuWeb pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1f",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.12)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.12)",
        "alpha": 0.12
      }
    },
    {
      "name": "Background/Dark/Chart",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1a",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Background/Dark/menuWeb hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFd",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.05)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.05)",
        "alpha": 0.05
      }
    },
    {
      "name": "Background/Dark/Button background on image",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Background/Dark/Keyboard",
      "values": {
        "hex": "#151515",
        "hexa": "#151515ff",
        "rgb": "rgb(21, 21, 21)",
        "rgba": "rgba(21, 21, 21, 1)",
        "hsl": "hsl(0, 0%, 8%)",
        "hsla": "hsl(0, 0%, 8%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Modal Secondary",
      "values": {
        "hex": "#1E1E1F",
        "hexa": "#1E1E1Fff",
        "rgb": "rgb(30, 30, 31)",
        "rgba": "rgba(30, 30, 31, 1)",
        "hsl": "hsl(240, 2%, 12%)",
        "hsla": "hsl(240, 2%, 12%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Clocked In",
      "values": {
        "hex": "#272729",
        "hexa": "#272729ff",
        "rgb": "rgb(39, 39, 41)",
        "rgba": "rgba(39, 39, 41, 1)",
        "hsl": "hsl(240, 3%, 16%)",
        "hsla": "hsl(240, 3%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Clocked Out",
      "values": {
        "hex": "#1D1D1F",
        "hexa": "#1D1D1Fff",
        "rgb": "rgb(29, 29, 31)",
        "rgba": "rgba(29, 29, 31, 1)",
        "hsl": "hsl(240, 3%, 12%)",
        "hsla": "hsl(240, 3%, 12%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Event",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Warning",
      "values": {
        "hex": "#E85344",
        "hexa": "#E85344ff",
        "rgb": "rgb(232, 83, 68)",
        "rgba": "rgba(232, 83, 68, 1)",
        "hsl": "hsl(5, 78%, 59%)",
        "hsla": "hsl(5, 78%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Corporate Web",
      "values": {
        "hex": "#282828",
        "hexa": "#282828ff",
        "rgb": "rgb(40, 40, 40)",
        "rgba": "rgba(40, 40, 40, 1)",
        "hsl": "hsl(0, 0%, 16%)",
        "hsla": "hsl(0, 0%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Submenu",
      "values": {
        "hex": "#1B1B1B",
        "hexa": "#1B1B1Bff",
        "rgb": "rgb(27, 27, 27)",
        "rgba": "rgba(27, 27, 27, 1)",
        "hsl": "hsl(0, 0%, 11%)",
        "hsla": "hsl(0, 0%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Production Information Missing",
      "values": {
        "hex": "#ECCA17",
        "hexa": "#ECCA17ff",
        "rgb": "rgb(236, 202, 23)",
        "rgba": "rgba(236, 202, 23, 1)",
        "hsl": "hsl(50, 85%, 51%)",
        "hsla": "hsl(50, 85%, 51%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Secondary on detail [mobile]",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Timeline",
      "values": {
        "hex": "#08080A",
        "hexa": "#08080Aff",
        "rgb": "rgb(8, 8, 10)",
        "rgba": "rgba(8, 8, 10, 1)",
        "hsl": "hsl(240, 11%, 4%)",
        "hsla": "hsl(240, 11%, 4%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Secondary on detail [web]",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/System [web] hover",
      "values": {
        "hex": "#373533",
        "hexa": "#373533ff",
        "rgb": "rgb(55, 53, 51)",
        "rgba": "rgba(55, 53, 51, 1)",
        "hsl": "hsl(30, 4%, 21%)",
        "hsla": "hsl(30, 4%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/System [web] pressed",
      "values": {
        "hex": "#454442",
        "hexa": "#454442ff",
        "rgb": "rgb(69, 68, 66)",
        "rgba": "rgba(69, 68, 66, 1)",
        "hsl": "hsl(40, 2%, 26%)",
        "hsla": "hsl(40, 2%, 26%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/menuWeb selector",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF8",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.03)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.03)",
        "alpha": 0.03
      }
    },
    {
      "name": "Background/Dark/Search & View Selector",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1a",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Background/Dark/Segmented Control",
      "values": {
        "hex": "#FAFAFA",
        "hexa": "#FAFAFA1a",
        "rgb": "rgb(250, 250, 250)",
        "rgba": "rgba(250, 250, 250, 0.1)",
        "hsl": "hsl(0, 0%, 98%)",
        "hsla": "hsl(0, 0%, 98%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Background/Dark/Panel background op top",
      "values": {
        "hex": "#141416",
        "hexa": "#141416ff",
        "rgb": "rgb(20, 20, 22)",
        "rgba": "rgba(20, 20, 22, 1)",
        "hsl": "hsl(240, 5%, 8%)",
        "hsla": "hsl(240, 5%, 8%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Tile No Picture",
      "values": {
        "hex": "#403F3D",
        "hexa": "#403F3Dff",
        "rgb": "rgb(64, 63, 61)",
        "rgba": "rgba(64, 63, 61, 1)",
        "hsl": "hsl(40, 2%, 25%)",
        "hsla": "hsl(40, 2%, 25%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Kiosk Primary",
      "values": {
        "hex": "#272728",
        "hexa": "#272728ff",
        "rgb": "rgb(39, 39, 40)",
        "rgba": "rgba(39, 39, 40, 1)",
        "hsl": "hsl(240, 1%, 15%)",
        "hsla": "hsl(240, 1%, 15%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Kiosk Secondary",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Panel Left Pane [mobile]",
      "values": {
        "hex": "#18181A",
        "hexa": "#18181Aff",
        "rgb": "rgb(24, 24, 26)",
        "rgba": "rgba(24, 24, 26, 1)",
        "hsl": "hsl(240, 4%, 10%)",
        "hsla": "hsl(240, 4%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Panel Left Pane [web]",
      "values": {
        "hex": "#18181A",
        "hexa": "#18181Aff",
        "rgb": "rgb(24, 24, 26)",
        "rgba": "rgba(24, 24, 26, 1)",
        "hsl": "hsl(240, 4%, 10%)",
        "hsla": "hsl(240, 4%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Status Bar",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on modal highlight",
      "values": {
        "hex": "#404042",
        "hexa": "#404042ff",
        "rgb": "rgb(64, 64, 66)",
        "rgba": "rgba(64, 64, 66, 1)",
        "hsl": "hsl(240, 2%, 25%)",
        "hsla": "hsl(240, 2%, 25%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on modal pressed",
      "values": {
        "hex": "#38383C",
        "hexa": "#38383Cff",
        "rgb": "rgb(56, 56, 60)",
        "rgba": "rgba(56, 56, 60, 1)",
        "hsl": "hsl(240, 3%, 23%)",
        "hsla": "hsl(240, 3%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on modal hover",
      "values": {
        "hex": "#343436",
        "hexa": "#343436ff",
        "rgb": "rgb(52, 52, 54)",
        "rgba": "rgba(52, 52, 54, 1)",
        "hsl": "hsl(240, 2%, 21%)",
        "hsla": "hsl(240, 2%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on modal highlight pressed",
      "values": {
        "hex": "#48484C",
        "hexa": "#48484Cff",
        "rgb": "rgb(72, 72, 76)",
        "rgba": "rgba(72, 72, 76, 1)",
        "hsl": "hsl(240, 3%, 29%)",
        "hsla": "hsl(240, 3%, 29%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on modal highlight hover",
      "values": {
        "hex": "#444446",
        "hexa": "#444446ff",
        "rgb": "rgb(68, 68, 70)",
        "rgba": "rgba(68, 68, 70, 1)",
        "hsl": "hsl(240, 1%, 27%)",
        "hsla": "hsl(240, 1%, 27%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Modal Highlight",
      "values": {
        "hex": "#353537",
        "hexa": "#353537ff",
        "rgb": "rgb(53, 53, 55)",
        "rgba": "rgba(53, 53, 55, 1)",
        "hsl": "hsl(240, 2%, 21%)",
        "hsla": "hsl(240, 2%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field very light",
      "values": {
        "hex": "#959598",
        "hexa": "#959598ff",
        "rgb": "rgb(149, 149, 152)",
        "rgba": "rgba(149, 149, 152, 1)",
        "hsl": "hsl(240, 1%, 59%)",
        "hsla": "hsl(240, 1%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field very light hover",
      "values": {
        "hex": "#6D6D74",
        "hexa": "#6D6D74ff",
        "rgb": "rgb(109, 109, 116)",
        "rgba": "rgba(109, 109, 116, 1)",
        "hsl": "hsl(240, 3%, 44%)",
        "hsla": "hsl(240, 3%, 44%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field very light pressed",
      "values": {
        "hex": "#4E4E54",
        "hexa": "#4E4E54ff",
        "rgb": "rgb(78, 78, 84)",
        "rgba": "rgba(78, 78, 84, 1)",
        "hsl": "hsl(240, 4%, 32%)",
        "hsla": "hsl(240, 4%, 32%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Button background on image black text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF99",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.6)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Background/Dark/Chart No Trans",
      "values": {
        "hex": "#2F2F31",
        "hexa": "#2F2F31ff",
        "rgb": "rgb(47, 47, 49)",
        "rgba": "rgba(47, 47, 49, 1)",
        "hsl": "hsl(240, 2%, 19%)",
        "hsla": "hsl(240, 2%, 19%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Field on Modal",
      "values": {
        "hex": "#323234",
        "hexa": "#323234ff",
        "rgb": "rgb(50, 50, 52)",
        "rgba": "rgba(50, 50, 52, 1)",
        "hsl": "hsl(240, 2%, 20%)",
        "hsla": "hsl(240, 2%, 20%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Event Grouped",
      "values": {
        "hex": "#2C2C2E",
        "hexa": "#2C2C2Eff",
        "rgb": "rgb(44, 44, 46)",
        "rgba": "rgba(44, 44, 46, 1)",
        "hsl": "hsl(240, 2%, 18%)",
        "hsla": "hsl(240, 2%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Event Trace",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Planboard - Behind",
      "values": {
        "hex": "#281816",
        "hexa": "#281816ff",
        "rgb": "rgb(40, 24, 22)",
        "rgba": "rgba(40, 24, 22, 1)",
        "hsl": "hsl(7, 29%, 12%)",
        "hsla": "hsl(7, 29%, 12%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Planboard - Ahead",
      "values": {
        "hex": "#222237",
        "hexa": "#222237ff",
        "rgb": "rgb(34, 34, 55)",
        "rgba": "rgba(34, 34, 55, 1)",
        "hsl": "hsl(240, 24%, 17%)",
        "hsla": "hsl(240, 24%, 17%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Background/Dark/Planboard - Waiting",
      "values": {
        "hex": "#3D3B30",
        "hexa": "#3D3B30ff",
        "rgb": "rgb(61, 59, 48)",
        "rgba": "rgba(61, 59, 48, 1)",
        "hsl": "hsl(51, 12%, 21%)",
        "hsla": "hsl(51, 12%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Active Background",
      "values": {
        "hex": "#EBFAEB",
        "hexa": "#EBFAEBff",
        "rgb": "rgb(235, 250, 235)",
        "rgba": "rgba(235, 250, 235, 1)",
        "hsl": "hsl(120, 60%, 95%)",
        "hsla": "hsl(120, 60%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Finished",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Finished Background",
      "values": {
        "hex": "#EBF6FA",
        "hexa": "#EBF6FAff",
        "rgb": "rgb(235, 246, 250)",
        "rgba": "rgba(235, 246, 250, 1)",
        "hsl": "hsl(196, 60%, 95%)",
        "hsla": "hsl(196, 60%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Paused",
      "values": {
        "hex": "#A2845E",
        "hexa": "#A2845Eff",
        "rgb": "rgb(162, 132, 94)",
        "rgba": "rgba(162, 132, 94, 1)",
        "hsl": "hsl(34, 27%, 50%)",
        "hsla": "hsl(34, 27%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Paused Background",
      "values": {
        "hex": "#FCF1DC",
        "hexa": "#FCF1DCff",
        "rgb": "rgb(252, 241, 220)",
        "rgba": "rgba(252, 241, 220, 1)",
        "hsl": "hsl(39, 84%, 93%)",
        "hsla": "hsl(39, 84%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Not Linked Background",
      "values": {
        "hex": "#FFF8C1",
        "hexa": "#FFF8C1ff",
        "rgb": "rgb(255, 248, 193)",
        "rgba": "rgba(255, 248, 193, 1)",
        "hsl": "hsl(53, 100%, 88%)",
        "hsla": "hsl(53, 100%, 88%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Ignored Background",
      "values": {
        "hex": "#E6E6E6",
        "hexa": "#E6E6E6ff",
        "rgb": "rgb(230, 230, 230)",
        "rgba": "rgba(230, 230, 230, 1)",
        "hsl": "hsl(0, 0%, 90%)",
        "hsla": "hsl(0, 0%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Not Ready To Start",
      "values": {
        "hex": "#F2F2F2",
        "hexa": "#F2F2F2ff",
        "rgb": "rgb(242, 242, 242)",
        "rgba": "rgba(242, 242, 242, 1)",
        "hsl": "hsl(0, 0%, 95%)",
        "hsla": "hsl(0, 0%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Ready To Start",
      "values": {
        "hex": "#FAF5FC",
        "hexa": "#FAF5FCff",
        "rgb": "rgb(250, 245, 252)",
        "rgba": "rgba(250, 245, 252, 1)",
        "hsl": "hsl(283, 54%, 97%)",
        "hsla": "hsl(283, 54%, 97%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Skipped",
      "values": {
        "hex": "#E6E6E6",
        "hexa": "#E6E6E6ff",
        "rgb": "rgb(230, 230, 230)",
        "rgba": "rgba(230, 230, 230, 1)",
        "hsl": "hsl(0, 0%, 90%)",
        "hsla": "hsl(0, 0%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Running",
      "values": {
        "hex": "#2DA0FC",
        "hexa": "#2DA0FCff",
        "rgb": "rgb(45, 160, 252)",
        "rgba": "rgba(45, 160, 252, 1)",
        "hsl": "hsl(207, 97%, 58%)",
        "hsla": "hsl(207, 97%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Pieces Completed",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Finish",
      "values": {
        "hex": "#377E22",
        "hexa": "#377E22ff",
        "rgb": "rgb(55, 126, 34)",
        "rgba": "rgba(55, 126, 34, 1)",
        "hsl": "hsl(106, 58%, 31%)",
        "hsla": "hsl(106, 58%, 31%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Paused hover",
      "values": {
        "hex": "#B49C7D",
        "hexa": "#B49C7Dff",
        "rgb": "rgb(180, 156, 125)",
        "rgba": "rgba(180, 156, 125, 1)",
        "hsl": "hsl(34, 27%, 60%)",
        "hsla": "hsl(34, 27%, 60%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Paused pressed",
      "values": {
        "hex": "#BCA78D",
        "hexa": "#BCA78Dff",
        "rgb": "rgb(188, 167, 141)",
        "rgba": "rgba(188, 167, 141, 1)",
        "hsl": "hsl(33, 26%, 65%)",
        "hsla": "hsl(33, 26%, 65%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Light/Running Background",
      "values": {
        "hex": "#DCEDFB",
        "hexa": "#DCEDFBff",
        "rgb": "rgb(220, 237, 251)",
        "rgba": "rgba(220, 237, 251, 1)",
        "hsl": "hsl(207, 79%, 92%)",
        "hsla": "hsl(207, 79%, 92%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Active Background",
      "values": {
        "hex": "#1C341C",
        "hexa": "#1C341Cff",
        "rgb": "rgb(28, 52, 28)",
        "rgba": "rgba(28, 52, 28, 1)",
        "hsl": "hsl(120, 30%, 16%)",
        "hsla": "hsl(120, 30%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Finished",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Finished Background",
      "values": {
        "hex": "#1E2F37",
        "hexa": "#1E2F37ff",
        "rgb": "rgb(30, 47, 55)",
        "rgba": "rgba(30, 47, 55, 1)",
        "hsl": "hsl(199, 29%, 17%)",
        "hsla": "hsl(199, 29%, 17%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Paused",
      "values": {
        "hex": "#AC8E68",
        "hexa": "#AC8E68ff",
        "rgb": "rgb(172, 142, 104)",
        "rgba": "rgba(172, 142, 104, 1)",
        "hsl": "hsl(34, 29%, 54%)",
        "hsla": "hsl(34, 29%, 54%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Paused Background",
      "values": {
        "hex": "#373026",
        "hexa": "#373026ff",
        "rgb": "rgb(55, 48, 38)",
        "rgba": "rgba(55, 48, 38, 1)",
        "hsl": "hsl(35, 18%, 18%)",
        "hsla": "hsl(35, 18%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Not Linked",
      "values": {
        "hex": "#332B00",
        "hexa": "#332B00ff",
        "rgb": "rgb(51, 43, 0)",
        "rgba": "rgba(51, 43, 0, 1)",
        "hsl": "hsl(51, 100%, 10%)",
        "hsla": "hsl(51, 100%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Ignored",
      "values": {
        "hex": "#333333",
        "hexa": "#333333ff",
        "rgb": "rgb(51, 51, 51)",
        "rgba": "rgba(51, 51, 51, 1)",
        "hsl": "hsl(0, 0%, 20%)",
        "hsla": "hsl(0, 0%, 20%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Not Ready To Start",
      "values": {
        "hex": "#272727",
        "hexa": "#272727ff",
        "rgb": "rgb(39, 39, 39)",
        "rgba": "rgba(39, 39, 39, 1)",
        "hsl": "hsl(0, 0%, 15%)",
        "hsla": "hsl(0, 0%, 15%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Ready To Start",
      "values": {
        "hex": "#2C2330",
        "hexa": "#2C2330ff",
        "rgb": "rgb(44, 35, 48)",
        "rgba": "rgba(44, 35, 48, 1)",
        "hsl": "hsl(282, 16%, 16%)",
        "hsla": "hsl(282, 16%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Skipped",
      "values": {
        "hex": "#333333",
        "hexa": "#333333ff",
        "rgb": "rgb(51, 51, 51)",
        "rgba": "rgba(51, 51, 51, 1)",
        "hsl": "hsl(0, 0%, 20%)",
        "hsla": "hsl(0, 0%, 20%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Running",
      "values": {
        "hex": "#1F90EA",
        "hexa": "#1F90EAff",
        "rgb": "rgb(31, 144, 234)",
        "rgba": "rgba(31, 144, 234, 1)",
        "hsl": "hsl(207, 83%, 52%)",
        "hsla": "hsl(207, 83%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Pieces Completed",
      "values": {
        "hex": "#D5D5D5",
        "hexa": "#D5D5D5ff",
        "rgb": "rgb(213, 213, 213)",
        "rgba": "rgba(213, 213, 213, 1)",
        "hsl": "hsl(0, 0%, 84%)",
        "hsla": "hsl(0, 0%, 84%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Finish",
      "values": {
        "hex": "#64B94B",
        "hexa": "#64B94Bff",
        "rgb": "rgb(100, 185, 75)",
        "rgba": "rgba(100, 185, 75, 1)",
        "hsl": "hsl(106, 44%, 51%)",
        "hsla": "hsl(106, 44%, 51%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Paused hover",
      "values": {
        "hex": "#8E7658",
        "hexa": "#8E7658ff",
        "rgb": "rgb(142, 118, 88)",
        "rgba": "rgba(142, 118, 88, 1)",
        "hsl": "hsl(33, 23%, 45%)",
        "hsla": "hsl(33, 23%, 45%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Paused pressed",
      "values": {
        "hex": "#806B51",
        "hexa": "#806B51ff",
        "rgb": "rgb(128, 107, 81)",
        "rgba": "rgba(128, 107, 81, 1)",
        "hsl": "hsl(33, 22%, 41%)",
        "hsla": "hsl(33, 22%, 41%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "ProdJobBatch/Dark/Running Background",
      "values": {
        "hex": "#1E2F37",
        "hexa": "#1E2F37ff",
        "rgb": "rgb(30, 47, 55)",
        "rgba": "rgba(30, 47, 55, 1)",
        "hsl": "hsl(199, 29%, 17%)",
        "hsla": "hsl(199, 29%, 17%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Primary",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Secondary",
      "values": {
        "hex": "#000064",
        "hexa": "#000064d",
        "rgb": "rgb(0, 0, 100)",
        "rgba": "rgba(0, 0, 100, 0.05)",
        "hsl": "hsl(240, 100%, 20%)",
        "hsla": "hsl(240, 100%, 20%, 0.05)",
        "alpha": 0.05
      }
    },
    {
      "name": "Button/Light/Tertiary",
      "values": {
        "hex": "#000000",
        "hexa": "#0000008",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.03)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.03)",
        "alpha": 0.03
      }
    },
    {
      "name": "Button/Light/Only Text",
      "values": {
        "hex": "#000000",
        "hexa": "#0000000",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Button/Light/Primary hover",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFcc",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 0.8)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Light/Secondary hover",
      "values": {
        "hex": "#000064",
        "hexa": "#0000641c",
        "rgb": "rgb(0, 0, 100)",
        "rgba": "rgba(0, 0, 100, 0.11)",
        "hsl": "hsl(240, 100%, 20%)",
        "hsla": "hsl(240, 100%, 20%, 0.11)",
        "alpha": 0.11
      }
    },
    {
      "name": "Button/Light/Tertiary hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000001c",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.11)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.11)",
        "alpha": 0.11
      }
    },
    {
      "name": "Button/Light/Only Text hover",
      "values": {
        "hex": "#000000",
        "hexa": "#000000d",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.05)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.05)",
        "alpha": 0.05
      }
    },
    {
      "name": "Button/Light/Primary pressed",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFb3",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 0.7)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Button/Light/Secondary pressed",
      "values": {
        "hex": "#000064",
        "hexa": "#00006433",
        "rgb": "rgb(0, 0, 100)",
        "rgba": "rgba(0, 0, 100, 0.2)",
        "hsl": "hsl(240, 100%, 20%)",
        "hsla": "hsl(240, 100%, 20%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Button/Light/Tertiary pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#00000033",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.2)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Button/Light/Only Text pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#0000001a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Button/Light/Disabled",
      "values": {
        "hex": "#000000",
        "hexa": "#000000a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.04)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.04)",
        "alpha": 0.04
      }
    },
    {
      "name": "Button/Light/On Picture",
      "values": {
        "hex": "#505050",
        "hexa": "#505050e6",
        "rgb": "rgb(80, 80, 80)",
        "rgba": "rgba(80, 80, 80, 0.9)",
        "hsl": "hsl(0, 0%, 31%)",
        "hsla": "hsl(0, 0%, 31%, 0.9)",
        "alpha": 0.9
      }
    },
    {
      "name": "Button/Light/On Picture hover",
      "values": {
        "hex": "#646464",
        "hexa": "#646464cc",
        "rgb": "rgb(100, 100, 100)",
        "rgba": "rgba(100, 100, 100, 0.8)",
        "hsl": "hsl(0, 0%, 39%)",
        "hsla": "hsl(0, 0%, 39%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Light/On Picture pressed",
      "values": {
        "hex": "#646464",
        "hexa": "#646464b3",
        "rgb": "rgb(100, 100, 100)",
        "rgba": "rgba(100, 100, 100, 0.7)",
        "hsl": "hsl(0, 0%, 39%)",
        "hsla": "hsl(0, 0%, 39%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Button/Light/Icon Web",
      "values": {
        "hex": "#000004",
        "hexa": "#000004b3",
        "rgb": "rgb(0, 0, 4)",
        "rgba": "rgba(0, 0, 4, 0.7)",
        "hsl": "hsl(240, 100%, 1%)",
        "hsla": "hsl(240, 100%, 1%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Button/Light/Icon Web hover",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Icon Web pressed",
      "values": {
        "hex": "#1D1D1F",
        "hexa": "#1D1D1F99",
        "rgb": "rgb(29, 29, 31)",
        "rgba": "rgba(29, 29, 31, 0.6)",
        "hsl": "hsl(240, 3%, 12%)",
        "hsla": "hsl(240, 3%, 12%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Light/Icon PhoneTab",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Icon PhoneTab hover",
      "values": {
        "hex": "#3395FF",
        "hexa": "#3395FFff",
        "rgb": "rgb(51, 149, 255)",
        "rgba": "rgba(51, 149, 255, 1)",
        "hsl": "hsl(211, 100%, 60%)",
        "hsla": "hsl(211, 100%, 60%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Icon PhoneTab pressed",
      "values": {
        "hex": "#4DA2FF",
        "hexa": "#4DA2FF80",
        "rgb": "rgb(77, 162, 255)",
        "rgba": "rgba(77, 162, 255, 0.5)",
        "hsl": "hsl(211, 100%, 65%)",
        "hsla": "hsl(211, 100%, 65%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Button/Light/Login",
      "values": {
        "hex": "#E51D73",
        "hexa": "#E51D73ff",
        "rgb": "rgb(229, 29, 115)",
        "rgba": "rgba(229, 29, 115, 1)",
        "hsl": "hsl(334, 79%, 51%)",
        "hsla": "hsl(334, 79%, 51%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Login hover",
      "values": {
        "hex": "#E51D73",
        "hexa": "#E51D73cc",
        "rgb": "rgb(229, 29, 115)",
        "rgba": "rgba(229, 29, 115, 0.8)",
        "hsl": "hsl(334, 79%, 51%)",
        "hsla": "hsl(334, 79%, 51%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Light/Login pressed",
      "values": {
        "hex": "#E51D73",
        "hexa": "#E51D7399",
        "rgb": "rgb(229, 29, 115)",
        "rgba": "rgba(229, 29, 115, 0.6)",
        "hsl": "hsl(334, 79%, 51%)",
        "hsla": "hsl(334, 79%, 51%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Light/PrimaryMono",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/PrimaryMono hover",
      "values": {
        "hex": "#1D1D1F",
        "hexa": "#1D1D1Fcc",
        "rgb": "rgb(29, 29, 31)",
        "rgba": "rgba(29, 29, 31, 0.8)",
        "hsl": "hsl(240, 3%, 12%)",
        "hsla": "hsl(240, 3%, 12%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Light/PrimaryMono pressed",
      "values": {
        "hex": "#1D1D1F",
        "hexa": "#1D1D1F99",
        "rgb": "rgb(29, 29, 31)",
        "rgba": "rgba(29, 29, 31, 0.6)",
        "hsl": "hsl(240, 3%, 12%)",
        "hsla": "hsl(240, 3%, 12%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Light/Primary Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Secondary Text",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Tertiary Text",
      "values": {
        "hex": "#636771",
        "hexa": "#636771ff",
        "rgb": "rgb(99, 103, 113)",
        "rgba": "rgba(99, 103, 113, 1)",
        "hsl": "hsl(223, 7%, 42%)",
        "hsla": "hsl(223, 7%, 42%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Only Text Text",
      "values": {
        "hex": "#8E8E8E",
        "hexa": "#8E8E8Eff",
        "rgb": "rgb(142, 142, 142)",
        "rgba": "rgba(142, 142, 142, 1)",
        "hsl": "hsl(0, 0%, 56%)",
        "hsla": "hsl(0, 0%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Mono Icon",
      "values": {
        "hex": "#010101",
        "hexa": "#010101ab",
        "rgb": "rgb(1, 1, 1)",
        "rgba": "rgba(1, 1, 1, 0.67)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.67)",
        "alpha": 0.67
      }
    },
    {
      "name": "Button/Light/Mono Icon hover",
      "values": {
        "hex": "#010101",
        "hexa": "#01010185",
        "rgb": "rgb(1, 1, 1)",
        "rgba": "rgba(1, 1, 1, 0.52)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.52)",
        "alpha": 0.52
      }
    },
    {
      "name": "Button/Light/Mono Icon pressed",
      "values": {
        "hex": "#010101",
        "hexa": "#01010173",
        "rgb": "rgb(1, 1, 1)",
        "rgba": "rgba(1, 1, 1, 0.45)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.45)",
        "alpha": 0.45
      }
    },
    {
      "name": "Button/Light/Mono Icon Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFf5",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.96)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.96)",
        "alpha": 0.96
      }
    },
    {
      "name": "Button/Light/TV",
      "values": {
        "hex": "#D7DEF3",
        "hexa": "#D7DEF3ff",
        "rgb": "rgb(215, 222, 243)",
        "rgba": "rgba(215, 222, 243, 1)",
        "hsl": "hsl(225, 54%, 90%)",
        "hsla": "hsl(225, 54%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/TV hover",
      "values": {
        "hex": "#E1E8FD",
        "hexa": "#E1E8FDff",
        "rgb": "rgb(225, 232, 253)",
        "rgba": "rgba(225, 232, 253, 1)",
        "hsl": "hsl(225, 88%, 94%)",
        "hsla": "hsl(225, 88%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/TV pressed",
      "values": {
        "hex": "#EBF2FD",
        "hexa": "#EBF2FDff",
        "rgb": "rgb(235, 242, 253)",
        "rgba": "rgba(235, 242, 253, 1)",
        "hsl": "hsl(217, 82%, 96%)",
        "hsla": "hsl(217, 82%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/TV Text",
      "values": {
        "hex": "#04043D",
        "hexa": "#04043Da6",
        "rgb": "rgb(4, 4, 61)",
        "rgba": "rgba(4, 4, 61, 0.65)",
        "hsl": "hsl(240, 88%, 13%)",
        "hsla": "hsl(240, 88%, 13%, 0.65)",
        "alpha": 0.65
      }
    },
    {
      "name": "Button/Light/On Tag",
      "values": {
        "hex": "#000008",
        "hexa": "#00000859",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.35)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.35)",
        "alpha": 0.35
      }
    },
    {
      "name": "Button/Light/On Tag hover",
      "values": {
        "hex": "#000008",
        "hexa": "#00000873",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.45)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.45)",
        "alpha": 0.45
      }
    },
    {
      "name": "Button/Light/On Tag pressed",
      "values": {
        "hex": "#000008",
        "hexa": "#00000880",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.5)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Button/Light/PrimaryMono Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/PrimaryMono Inverted",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/PrimaryMono Inverted hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFde",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.87)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.87)",
        "alpha": 0.87
      }
    },
    {
      "name": "Button/Light/PrimaryMono Inverted pressed",
      "values": {
        "hex": "#E8E8E8",
        "hexa": "#E8E8E8ff",
        "rgb": "rgb(232, 232, 232)",
        "rgba": "rgba(232, 232, 232, 1)",
        "hsl": "hsl(0, 0%, 91%)",
        "hsla": "hsl(0, 0%, 91%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/PrimaryMono Inverted Text",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Operator Panel [Setup]",
      "values": {
        "hex": "#693772",
        "hexa": "#693772ff",
        "rgb": "rgb(105, 55, 114)",
        "rgba": "rgba(105, 55, 114, 1)",
        "hsl": "hsl(291, 35%, 33%)",
        "hsla": "hsl(291, 35%, 33%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Operator Panel [Active]",
      "values": {
        "hex": "#448153",
        "hexa": "#448153ff",
        "rgb": "rgb(68, 129, 83)",
        "rgba": "rgba(68, 129, 83, 1)",
        "hsl": "hsl(135, 31%, 39%)",
        "hsla": "hsl(135, 31%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Operator Panel [Change]",
      "values": {
        "hex": "#BC771D",
        "hexa": "#BC771Dff",
        "rgb": "rgb(188, 119, 29)",
        "rgba": "rgba(188, 119, 29, 1)",
        "hsl": "hsl(34, 73%, 43%)",
        "hsla": "hsl(34, 73%, 43%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Operator Panel [Not Productive]",
      "values": {
        "hex": "#585858",
        "hexa": "#585858ff",
        "rgb": "rgb(88, 88, 88)",
        "rgba": "rgba(88, 88, 88, 1)",
        "hsl": "hsl(0, 0%, 35%)",
        "hsla": "hsl(0, 0%, 35%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Always White",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Always White hover",
      "values": {
        "hex": "#F2F2F2",
        "hexa": "#F2F2F2ff",
        "rgb": "rgb(242, 242, 242)",
        "rgba": "rgba(242, 242, 242, 1)",
        "hsl": "hsl(0, 0%, 95%)",
        "hsla": "hsl(0, 0%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Always White pressed",
      "values": {
        "hex": "#E5E5E5",
        "hexa": "#E5E5E5ff",
        "rgb": "rgb(229, 229, 229)",
        "rgba": "rgba(229, 229, 229, 1)",
        "hsl": "hsl(0, 0%, 90%)",
        "hsla": "hsl(0, 0%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Light/Always White Text",
      "values": {
        "hex": "#307BF6",
        "hexa": "#307BF6ff",
        "rgb": "rgb(48, 123, 246)",
        "rgba": "rgba(48, 123, 246, 1)",
        "hsl": "hsl(217, 92%, 58%)",
        "hsla": "hsl(217, 92%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Primary",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Tertiary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF26",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.15)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.15)",
        "alpha": 0.15
      }
    },
    {
      "name": "Button/Dark/Primary hover",
      "values": {
        "hex": "#559EF8",
        "hexa": "#559EF8cc",
        "rgb": "rgb(85, 158, 248)",
        "rgba": "rgba(85, 158, 248, 0.8)",
        "hsl": "hsl(213, 92%, 65%)",
        "hsla": "hsl(213, 92%, 65%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Dark/Primary pressed",
      "values": {
        "hex": "#559EF8",
        "hexa": "#559EF8b3",
        "rgb": "rgb(85, 158, 248)",
        "rgba": "rgba(85, 158, 248, 0.7)",
        "hsl": "hsl(213, 92%, 65%)",
        "hsla": "hsl(213, 92%, 65%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Button/Dark/Secondary",
      "values": {
        "hex": "#F5F5FF",
        "hexa": "#F5F5FF2e",
        "rgb": "rgb(245, 245, 255)",
        "rgba": "rgba(245, 245, 255, 0.18)",
        "hsl": "hsl(240, 100%, 98%)",
        "hsla": "hsl(240, 100%, 98%, 0.18)",
        "alpha": 0.18
      }
    },
    {
      "name": "Button/Dark/Secondary hover",
      "values": {
        "hex": "#F5F5FF",
        "hexa": "#F5F5FF40",
        "rgb": "rgb(245, 245, 255)",
        "rgba": "rgba(245, 245, 255, 0.25)",
        "hsl": "hsl(240, 100%, 98%)",
        "hsla": "hsl(240, 100%, 98%, 0.25)",
        "alpha": 0.25
      }
    },
    {
      "name": "Button/Dark/Secondary pressed",
      "values": {
        "hex": "#F5F5FF",
        "hexa": "#F5F5FF59",
        "rgb": "rgb(245, 245, 255)",
        "rgba": "rgba(245, 245, 255, 0.35)",
        "hsl": "hsl(240, 100%, 98%)",
        "hsla": "hsl(240, 100%, 98%, 0.35)",
        "alpha": 0.35
      }
    },
    {
      "name": "Button/Dark/Tertiary hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Button/Dark/Tertiary pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF4d",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.3)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Button/Dark/Disabled",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFd",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.05)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.05)",
        "alpha": 0.05
      }
    },
    {
      "name": "Button/Dark/Only Text hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Button/Dark/Only Text pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF4d",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.3)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Button/Dark/Only Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF0",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Button/Dark/On Picture",
      "values": {
        "hex": "#505050",
        "hexa": "#505050e6",
        "rgb": "rgb(80, 80, 80)",
        "rgba": "rgba(80, 80, 80, 0.9)",
        "hsl": "hsl(0, 0%, 31%)",
        "hsla": "hsl(0, 0%, 31%, 0.9)",
        "alpha": 0.9
      }
    },
    {
      "name": "Button/Dark/On Picture hover",
      "values": {
        "hex": "#646464",
        "hexa": "#646464cc",
        "rgb": "rgb(100, 100, 100)",
        "rgba": "rgba(100, 100, 100, 0.8)",
        "hsl": "hsl(0, 0%, 39%)",
        "hsla": "hsl(0, 0%, 39%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Dark/On Picture pressed",
      "values": {
        "hex": "#646464",
        "hexa": "#646464b3",
        "rgb": "rgb(100, 100, 100)",
        "rgba": "rgba(100, 100, 100, 0.7)",
        "hsl": "hsl(0, 0%, 39%)",
        "hsla": "hsl(0, 0%, 39%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Button/Dark/Icon Web pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF99",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.6)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Dark/Icon Web hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Icon Web",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFcc",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.8)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Dark/Icon PhoneTab pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF99",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.6)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Dark/Icon PhoneTab hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFde",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.87)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.87)",
        "alpha": 0.87
      }
    },
    {
      "name": "Button/Dark/Icon PhoneTab",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Login",
      "values": {
        "hex": "#C02064",
        "hexa": "#C02064ff",
        "rgb": "rgb(192, 32, 100)",
        "rgba": "rgba(192, 32, 100, 1)",
        "hsl": "hsl(335, 71%, 44%)",
        "hsla": "hsl(335, 71%, 44%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Login hover",
      "values": {
        "hex": "#C02064",
        "hexa": "#C02064cc",
        "rgb": "rgb(192, 32, 100)",
        "rgba": "rgba(192, 32, 100, 0.8)",
        "hsl": "hsl(335, 71%, 44%)",
        "hsla": "hsl(335, 71%, 44%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Dark/Login pressed",
      "values": {
        "hex": "#C02064",
        "hexa": "#C0206499",
        "rgb": "rgb(192, 32, 100)",
        "rgba": "rgba(192, 32, 100, 0.6)",
        "hsl": "hsl(335, 71%, 44%)",
        "hsla": "hsl(335, 71%, 44%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Dark/PrimaryMono",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/PrimaryMono hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFde",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.87)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.87)",
        "alpha": 0.87
      }
    },
    {
      "name": "Button/Dark/PrimaryMono pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF99",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.6)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Dark/Primary Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Secondary Text",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Tertiary Text",
      "values": {
        "hex": "#9C9C9C",
        "hexa": "#9C9C9Cff",
        "rgb": "rgb(156, 156, 156)",
        "rgba": "rgba(156, 156, 156, 1)",
        "hsl": "hsl(0, 0%, 61%)",
        "hsla": "hsl(0, 0%, 61%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Only Text Text",
      "values": {
        "hex": "#8E8E8E",
        "hexa": "#8E8E8Eff",
        "rgb": "rgb(142, 142, 142)",
        "rgba": "rgba(142, 142, 142, 1)",
        "hsl": "hsl(0, 0%, 56%)",
        "hsla": "hsl(0, 0%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Mono Icon",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFe8",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.91)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.91)",
        "alpha": 0.91
      }
    },
    {
      "name": "Button/Dark/Mono Icon hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Mono Icon pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFcc",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.8)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Dark/Mono Icon Text",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/TV Text",
      "values": {
        "hex": "#E8EAED",
        "hexa": "#E8EAEDff",
        "rgb": "rgb(232, 234, 237)",
        "rgba": "rgba(232, 234, 237, 1)",
        "hsl": "hsl(216, 12%, 92%)",
        "hsla": "hsl(216, 12%, 92%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/TV",
      "values": {
        "hex": "#475266",
        "hexa": "#475266ff",
        "rgb": "rgb(71, 82, 102)",
        "rgba": "rgba(71, 82, 102, 1)",
        "hsl": "hsl(219, 18%, 34%)",
        "hsla": "hsl(219, 18%, 34%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/TV hover",
      "values": {
        "hex": "#3A4455",
        "hexa": "#3A4455ff",
        "rgb": "rgb(58, 68, 85)",
        "rgba": "rgba(58, 68, 85, 1)",
        "hsl": "hsl(218, 19%, 28%)",
        "hsla": "hsl(218, 19%, 28%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/TV pressed",
      "values": {
        "hex": "#3A4455",
        "hexa": "#3A4455ff",
        "rgb": "rgb(58, 68, 85)",
        "rgba": "rgba(58, 68, 85, 1)",
        "hsl": "hsl(218, 19%, 28%)",
        "hsla": "hsl(218, 19%, 28%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/On Tag",
      "values": {
        "hex": "#000008",
        "hexa": "#00000859",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.35)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.35)",
        "alpha": 0.35
      }
    },
    {
      "name": "Button/Dark/On Tag hover",
      "values": {
        "hex": "#000008",
        "hexa": "#00000873",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.45)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.45)",
        "alpha": 0.45
      }
    },
    {
      "name": "Button/Dark/On Tag pressed",
      "values": {
        "hex": "#000008",
        "hexa": "#00000880",
        "rgb": "rgb(0, 0, 8)",
        "rgba": "rgba(0, 0, 8, 0.5)",
        "hsl": "hsl(240, 100%, 2%)",
        "hsla": "hsl(240, 100%, 2%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Button/Dark/PrimaryMono Text",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/PrimaryMono Inverted",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/PrimaryMono Inverted hover",
      "values": {
        "hex": "#1D1D1F",
        "hexa": "#1D1D1Fcc",
        "rgb": "rgb(29, 29, 31)",
        "rgba": "rgba(29, 29, 31, 0.8)",
        "hsl": "hsl(240, 3%, 12%)",
        "hsla": "hsl(240, 3%, 12%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Button/Dark/PrimaryMono Inverted pressed",
      "values": {
        "hex": "#1D1D1F",
        "hexa": "#1D1D1F99",
        "rgb": "rgb(29, 29, 31)",
        "rgba": "rgba(29, 29, 31, 0.6)",
        "hsl": "hsl(240, 3%, 12%)",
        "hsla": "hsl(240, 3%, 12%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Button/Dark/PrimaryMono Inverted Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Operator Panel [Setup]",
      "values": {
        "hex": "#693772",
        "hexa": "#693772ff",
        "rgb": "rgb(105, 55, 114)",
        "rgba": "rgba(105, 55, 114, 1)",
        "hsl": "hsl(291, 35%, 33%)",
        "hsla": "hsl(291, 35%, 33%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Operator Panel [Active]",
      "values": {
        "hex": "#448153",
        "hexa": "#448153ff",
        "rgb": "rgb(68, 129, 83)",
        "rgba": "rgba(68, 129, 83, 1)",
        "hsl": "hsl(135, 31%, 39%)",
        "hsla": "hsl(135, 31%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Operator Panel [Change]",
      "values": {
        "hex": "#BC771D",
        "hexa": "#BC771Dff",
        "rgb": "rgb(188, 119, 29)",
        "rgba": "rgba(188, 119, 29, 1)",
        "hsl": "hsl(34, 73%, 43%)",
        "hsla": "hsl(34, 73%, 43%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Operator Panel [Not Productive]",
      "values": {
        "hex": "#585858",
        "hexa": "#585858ff",
        "rgb": "rgb(88, 88, 88)",
        "rgba": "rgba(88, 88, 88, 1)",
        "hsl": "hsl(0, 0%, 35%)",
        "hsla": "hsl(0, 0%, 35%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Always White",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Always White hover",
      "values": {
        "hex": "#F2F2F2",
        "hexa": "#F2F2F2ff",
        "rgb": "rgb(242, 242, 242)",
        "rgba": "rgba(242, 242, 242, 1)",
        "hsl": "hsl(0, 0%, 95%)",
        "hsla": "hsl(0, 0%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Always White pressed",
      "values": {
        "hex": "#E5E5E5",
        "hexa": "#E5E5E5ff",
        "rgb": "rgb(229, 229, 229)",
        "rgba": "rgba(229, 229, 229, 1)",
        "hsl": "hsl(0, 0%, 90%)",
        "hsla": "hsl(0, 0%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Button/Dark/Always White Text",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Dark/Primary",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF40",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.25)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.25)",
        "alpha": 0.25
      }
    },
    {
      "name": "Hairline/Dark/Secondary",
      "values": {
        "hex": "#504E4D",
        "hexa": "#504E4Dff",
        "rgb": "rgb(80, 78, 77)",
        "rgba": "rgba(80, 78, 77, 1)",
        "hsl": "hsl(20, 2%, 31%)",
        "hsla": "hsl(20, 2%, 31%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Dark/Header",
      "values": {
        "hex": "#636363",
        "hexa": "#636363ff",
        "rgb": "rgb(99, 99, 99)",
        "rgba": "rgba(99, 99, 99, 1)",
        "hsl": "hsl(0, 0%, 39%)",
        "hsla": "hsl(0, 0%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Dark/No trans [mobile]",
      "values": {
        "hex": "#38383A",
        "hexa": "#38383Aff",
        "rgb": "rgb(56, 56, 58)",
        "rgba": "rgba(56, 56, 58, 1)",
        "hsl": "hsl(240, 2%, 22%)",
        "hsla": "hsl(240, 2%, 22%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Dark/No trans [web]",
      "values": {
        "hex": "#38383A",
        "hexa": "#38383Aff",
        "rgb": "rgb(56, 56, 58)",
        "rgba": "rgba(56, 56, 58, 1)",
        "hsl": "hsl(240, 2%, 22%)",
        "hsla": "hsl(240, 2%, 22%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Dark/Transpar [mobile]",
      "values": {
        "hex": "#545458",
        "hexa": "#545458a6",
        "rgb": "rgb(84, 84, 88)",
        "rgba": "rgba(84, 84, 88, 0.65)",
        "hsl": "hsl(240, 2%, 34%)",
        "hsla": "hsl(240, 2%, 34%, 0.65)",
        "alpha": 0.65
      }
    },
    {
      "name": "Hairline/Dark/Transpar [web]",
      "values": {
        "hex": "#545458",
        "hexa": "#545458a6",
        "rgb": "rgb(84, 84, 88)",
        "rgba": "rgba(84, 84, 88, 0.65)",
        "hsl": "hsl(240, 2%, 34%)",
        "hsla": "hsl(240, 2%, 34%, 0.65)",
        "alpha": 0.65
      }
    },
    {
      "name": "Hairline/Dark/Transpar [tv]",
      "values": {
        "hex": "#545458",
        "hexa": "#545458a6",
        "rgb": "rgb(84, 84, 88)",
        "rgba": "rgba(84, 84, 88, 0.65)",
        "hsl": "hsl(240, 2%, 34%)",
        "hsla": "hsl(240, 2%, 34%, 0.65)",
        "alpha": 0.65
      }
    },
    {
      "name": "Hairline/Light/Primary",
      "values": {
        "hex": "#000000",
        "hexa": "#00000038",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.22)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.22)",
        "alpha": 0.22
      }
    },
    {
      "name": "Hairline/Light/Secondary",
      "values": {
        "hex": "#D9D9D9",
        "hexa": "#D9D9D9ff",
        "rgb": "rgb(217, 217, 217)",
        "rgba": "rgba(217, 217, 217, 1)",
        "hsl": "hsl(0, 0%, 85%)",
        "hsla": "hsl(0, 0%, 85%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Light/Header",
      "values": {
        "hex": "#8B8B8D",
        "hexa": "#8B8B8Dff",
        "rgb": "rgb(139, 139, 141)",
        "rgba": "rgba(139, 139, 141, 1)",
        "hsl": "hsl(240, 1%, 55%)",
        "hsla": "hsl(240, 1%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Light/No trans [mobile]",
      "values": {
        "hex": "#C6C6C8",
        "hexa": "#C6C6C8ff",
        "rgb": "rgb(198, 198, 200)",
        "rgba": "rgba(198, 198, 200, 1)",
        "hsl": "hsl(240, 2%, 78%)",
        "hsla": "hsl(240, 2%, 78%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Light/No trans [web]",
      "values": {
        "hex": "#DDDDDD",
        "hexa": "#DDDDDDff",
        "rgb": "rgb(221, 221, 221)",
        "rgba": "rgba(221, 221, 221, 1)",
        "hsl": "hsl(0, 0%, 87%)",
        "hsla": "hsl(0, 0%, 87%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hairline/Light/Transpar [mobile]",
      "values": {
        "hex": "#3C3C43",
        "hexa": "#3C3C435c",
        "rgb": "rgb(60, 60, 67)",
        "rgba": "rgba(60, 60, 67, 0.36)",
        "hsl": "hsl(240, 6%, 25%)",
        "hsla": "hsl(240, 6%, 25%, 0.36)",
        "alpha": 0.36
      }
    },
    {
      "name": "Hairline/Light/Transpar [web]",
      "values": {
        "hex": "#3C3C43",
        "hexa": "#3C3C433d",
        "rgb": "rgb(60, 60, 67)",
        "rgba": "rgba(60, 60, 67, 0.24)",
        "hsl": "hsl(240, 6%, 25%)",
        "hsla": "hsl(240, 6%, 25%, 0.24)",
        "alpha": 0.24
      }
    },
    {
      "name": "Hairline/Light/Transpar [tv]",
      "values": {
        "hex": "#444776",
        "hexa": "#4447765c",
        "rgb": "rgb(68, 71, 118)",
        "rgba": "rgba(68, 71, 118, 0.36)",
        "hsl": "hsl(236, 27%, 36%)",
        "hsla": "hsl(236, 27%, 36%, 0.36)",
        "alpha": 0.36
      }
    },
    {
      "name": "Link/Light/Primary",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Link/Light/Special",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Link/Dark/Primary",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Link/Dark/Special",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Primary",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Secondary",
      "values": {
        "hex": "#EEEEEE",
        "hexa": "#EEEEEEff",
        "rgb": "rgb(238, 238, 238)",
        "rgba": "rgba(238, 238, 238, 1)",
        "hsl": "hsl(0, 0%, 93%)",
        "hsla": "hsl(0, 0%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/List item",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Slider",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Primary hover",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFcc",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 0.8)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Selected/Light/Primary pressed",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFb3",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 0.7)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Selected/Light/Secondary hover",
      "values": {
        "hex": "#000000",
        "hexa": "#0000001c",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.11)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.11)",
        "alpha": 0.11
      }
    },
    {
      "name": "Selected/Light/Secondary pressed",
      "values": {
        "hex": "#000000",
        "hexa": "#00000033",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.2)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Selected/Light/Slider Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Slider Add Text",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Slider Add",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/List Item Secondary",
      "values": {
        "hex": "#EFF4FB",
        "hexa": "#EFF4FBff",
        "rgb": "rgb(239, 244, 251)",
        "rgba": "rgba(239, 244, 251, 1)",
        "hsl": "hsl(215, 60%, 96%)",
        "hsla": "hsl(215, 60%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/List Item Secondary hover",
      "values": {
        "hex": "#E7EEF9",
        "hexa": "#E7EEF9ff",
        "rgb": "rgb(231, 238, 249)",
        "rgba": "rgba(231, 238, 249, 1)",
        "hsl": "hsl(217, 60%, 94%)",
        "hsla": "hsl(217, 60%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Left Pane Menu Item",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Slider Main Unselected",
      "values": {
        "hex": "#D3E8FF",
        "hexa": "#D3E8FFff",
        "rgb": "rgb(211, 232, 255)",
        "rgba": "rgba(211, 232, 255, 1)",
        "hsl": "hsl(211, 100%, 91%)",
        "hsla": "hsl(211, 100%, 91%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Main Unselected Hover",
      "values": {
        "hex": "#B3D7FF",
        "hexa": "#B3D7FFff",
        "rgb": "rgb(179, 215, 255)",
        "rgba": "rgba(179, 215, 255, 1)",
        "hsl": "hsl(212, 100%, 85%)",
        "hsla": "hsl(212, 100%, 85%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Slider Main Unselected Text",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Light/Slider Main Unselected Hover",
      "values": {
        "hex": "#354E71",
        "hexa": "#354E71ff",
        "rgb": "rgb(53, 78, 113)",
        "rgba": "rgba(53, 78, 113, 1)",
        "hsl": "hsl(215, 36%, 33%)",
        "hsla": "hsl(215, 36%, 33%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Primary",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Secondary",
      "values": {
        "hex": "#646469",
        "hexa": "#646469ff",
        "rgb": "rgb(100, 100, 105)",
        "rgba": "rgba(100, 100, 105, 1)",
        "hsl": "hsl(240, 2%, 40%)",
        "hsla": "hsl(240, 2%, 40%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/List item",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Slider",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Secondary hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Selected/Dark/Secondary pressed",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF4d",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.3)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Selected/Dark/Primary hover",
      "values": {
        "hex": "#559EF8",
        "hexa": "#559EF8cc",
        "rgb": "rgb(85, 158, 248)",
        "rgba": "rgba(85, 158, 248, 0.8)",
        "hsl": "hsl(213, 92%, 65%)",
        "hsla": "hsl(213, 92%, 65%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Selected/Dark/Primary pressed",
      "values": {
        "hex": "#559EF8",
        "hexa": "#559EF8b3",
        "rgb": "rgb(85, 158, 248)",
        "rgba": "rgba(85, 158, 248, 0.7)",
        "hsl": "hsl(213, 92%, 65%)",
        "hsla": "hsl(213, 92%, 65%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Selected/Dark/Slider Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Slider Add Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Slider Add",
      "values": {
        "hex": "#646469",
        "hexa": "#646469ff",
        "rgb": "rgb(100, 100, 105)",
        "rgba": "rgba(100, 100, 105, 1)",
        "hsl": "hsl(240, 2%, 40%)",
        "hsla": "hsl(240, 2%, 40%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/List Item Secondary",
      "values": {
        "hex": "#262F38",
        "hexa": "#262F38ff",
        "rgb": "rgb(38, 47, 56)",
        "rgba": "rgba(38, 47, 56, 1)",
        "hsl": "hsl(210, 19%, 18%)",
        "hsla": "hsl(210, 19%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/List Item Secondary hover",
      "values": {
        "hex": "#2F3B46",
        "hexa": "#2F3B46ff",
        "rgb": "rgb(47, 59, 70)",
        "rgba": "rgba(47, 59, 70, 1)",
        "hsl": "hsl(209, 20%, 23%)",
        "hsla": "hsl(209, 20%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Left Pane Menu Item",
      "values": {
        "hex": "#404042",
        "hexa": "#404042ff",
        "rgb": "rgb(64, 64, 66)",
        "rgba": "rgba(64, 64, 66, 1)",
        "hsl": "hsl(240, 2%, 25%)",
        "hsla": "hsl(240, 2%, 25%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Slider Main Unselected",
      "values": {
        "hex": "#33445C",
        "hexa": "#33445Cff",
        "rgb": "rgb(51, 68, 92)",
        "rgba": "rgba(51, 68, 92, 1)",
        "hsl": "hsl(215, 29%, 28%)",
        "hsla": "hsl(215, 29%, 28%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Selected/Dark/Slider Main Unselected Text",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/TEEP Chart",
      "values": {
        "hex": "#E51D73",
        "hexa": "#E51D7366",
        "rgb": "rgb(229, 29, 115)",
        "rgba": "rgba(229, 29, 115, 0.4)",
        "hsl": "hsl(334, 79%, 51%)",
        "hsla": "hsl(334, 79%, 51%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "OEE/Light/TEEP",
      "values": {
        "hex": "#EE6EA5",
        "hexa": "#EE6EA5ff",
        "rgb": "rgb(238, 110, 165)",
        "rgba": "rgba(238, 110, 165, 1)",
        "hsl": "hsl(334, 79%, 68%)",
        "hsla": "hsl(334, 79%, 68%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/OEE Chart",
      "values": {
        "hex": "#30B0C7",
        "hexa": "#30B0C7ff",
        "rgb": "rgb(48, 176, 199)",
        "rgba": "rgba(48, 176, 199, 1)",
        "hsl": "hsl(189, 61%, 48%)",
        "hsla": "hsl(189, 61%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/OEE",
      "values": {
        "hex": "#7CCDDB",
        "hexa": "#7CCDDBff",
        "rgb": "rgb(124, 205, 219)",
        "rgba": "rgba(124, 205, 219, 1)",
        "hsl": "hsl(189, 57%, 67%)",
        "hsla": "hsl(189, 57%, 67%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/All Time",
      "values": {
        "hex": "#9FD4FF",
        "hexa": "#9FD4FFff",
        "rgb": "rgb(159, 212, 255)",
        "rgba": "rgba(159, 212, 255, 1)",
        "hsl": "hsl(207, 100%, 81%)",
        "hsla": "hsl(207, 100%, 81%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/Factor",
      "values": {
        "hex": "#A3DD9A",
        "hexa": "#A3DD9Aff",
        "rgb": "rgb(163, 221, 154)",
        "rgba": "rgba(163, 221, 154, 1)",
        "hsl": "hsl(112, 50%, 74%)",
        "hsla": "hsl(112, 50%, 74%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/Loss",
      "values": {
        "hex": "#FFCCCE",
        "hexa": "#FFCCCEff",
        "rgb": "rgb(255, 204, 206)",
        "rgba": "rgba(255, 204, 206, 1)",
        "hsl": "hsl(358, 100%, 90%)",
        "hsla": "hsl(358, 100%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/OEE On Selected",
      "values": {
        "hex": "#5BD6EC",
        "hexa": "#5BD6ECff",
        "rgb": "rgb(91, 214, 236)",
        "rgba": "rgba(91, 214, 236, 1)",
        "hsl": "hsl(189, 79%, 64%)",
        "hsla": "hsl(189, 79%, 64%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/Score Poor",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 83%, 58%)",
        "hsla": "hsl(5, 83%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/Score Fair",
      "values": {
        "hex": "#FF9500",
        "hexa": "#FF9500ff",
        "rgb": "rgb(255, 149, 0)",
        "rgba": "rgba(255, 149, 0, 1)",
        "hsl": "hsl(35, 100%, 50%)",
        "hsla": "hsl(35, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/Score Good",
      "values": {
        "hex": "#34C759",
        "hexa": "#34C759ff",
        "rgb": "rgb(52, 199, 89)",
        "rgba": "rgba(52, 199, 89, 1)",
        "hsl": "hsl(135, 59%, 49%)",
        "hsla": "hsl(135, 59%, 49%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/Score Excellent",
      "values": {
        "hex": "#30B0C7",
        "hexa": "#30B0C7ff",
        "rgb": "rgb(48, 176, 199)",
        "rgba": "rgba(48, 176, 199, 1)",
        "hsl": "hsl(189, 61%, 48%)",
        "hsla": "hsl(189, 61%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Light/Score World Class",
      "values": {
        "hex": "#5856D6",
        "hexa": "#5856D6ff",
        "rgb": "rgb(88, 86, 214)",
        "rgba": "rgba(88, 86, 214, 1)",
        "hsl": "hsl(241, 61%, 59%)",
        "hsla": "hsl(241, 61%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/TEEP Chart",
      "values": {
        "hex": "#F04A90",
        "hexa": "#F04A9066",
        "rgb": "rgb(240, 74, 144)",
        "rgba": "rgba(240, 74, 144, 0.4)",
        "hsl": "hsl(335, 85%, 62%)",
        "hsla": "hsl(335, 85%, 62%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "OEE/Dark/TEEP",
      "values": {
        "hex": "#C9447B",
        "hexa": "#C9447Bff",
        "rgb": "rgb(201, 68, 123)",
        "rgba": "rgba(201, 68, 123, 1)",
        "hsl": "hsl(335, 55%, 53%)",
        "hsla": "hsl(335, 55%, 53%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/OEE Chart",
      "values": {
        "hex": "#287D8D",
        "hexa": "#287D8Dff",
        "rgb": "rgb(40, 125, 141)",
        "rgba": "rgba(40, 125, 141, 1)",
        "hsl": "hsl(190, 56%, 35%)",
        "hsla": "hsl(190, 56%, 35%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/OEE",
      "values": {
        "hex": "#2C8191",
        "hexa": "#2C8191ff",
        "rgb": "rgb(44, 129, 145)",
        "rgba": "rgba(44, 129, 145, 1)",
        "hsl": "hsl(190, 53%, 37%)",
        "hsla": "hsl(190, 53%, 37%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/All Time",
      "values": {
        "hex": "#406787",
        "hexa": "#406787ff",
        "rgb": "rgb(64, 103, 135)",
        "rgba": "rgba(64, 103, 135, 1)",
        "hsl": "hsl(207, 36%, 39%)",
        "hsla": "hsl(207, 36%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/Factor",
      "values": {
        "hex": "#4A6B4A",
        "hexa": "#4A6B4Aff",
        "rgb": "rgb(74, 107, 74)",
        "rgba": "rgba(74, 107, 74, 1)",
        "hsl": "hsl(120, 18%, 35%)",
        "hsla": "hsl(120, 18%, 35%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/Loss",
      "values": {
        "hex": "#482929",
        "hexa": "#482929ff",
        "rgb": "rgb(72, 41, 41)",
        "rgba": "rgba(72, 41, 41, 1)",
        "hsl": "hsl(0, 27%, 22%)",
        "hsla": "hsl(0, 27%, 22%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/OEE On Selected",
      "values": {
        "hex": "#5BD6EC",
        "hexa": "#5BD6ECff",
        "rgb": "rgb(91, 214, 236)",
        "rgba": "rgba(91, 214, 236, 1)",
        "hsl": "hsl(189, 79%, 64%)",
        "hsla": "hsl(189, 79%, 64%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/Score Poor",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 83%, 58%)",
        "hsla": "hsl(5, 83%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/Score Fair",
      "values": {
        "hex": "#FF9F0A",
        "hexa": "#FF9F0Aff",
        "rgb": "rgb(255, 159, 10)",
        "rgba": "rgba(255, 159, 10, 1)",
        "hsl": "hsl(36, 100%, 52%)",
        "hsla": "hsl(36, 100%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/Score Good",
      "values": {
        "hex": "#32D74B",
        "hexa": "#32D74Bff",
        "rgb": "rgb(50, 215, 75)",
        "rgba": "rgba(50, 215, 75, 1)",
        "hsl": "hsl(129, 66%, 52%)",
        "hsla": "hsl(129, 66%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/Score Excellent",
      "values": {
        "hex": "#40C8E0",
        "hexa": "#40C8E0ff",
        "rgb": "rgb(64, 200, 224)",
        "rgba": "rgba(64, 200, 224, 1)",
        "hsl": "hsl(189, 72%, 56%)",
        "hsla": "hsl(189, 72%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "OEE/Dark/Score World Class",
      "values": {
        "hex": "#5E5CE6",
        "hexa": "#5E5CE6ff",
        "rgb": "rgb(94, 92, 230)",
        "rgba": "rgba(94, 92, 230, 1)",
        "hsl": "hsl(241, 73%, 63%)",
        "hsla": "hsl(241, 73%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Overlay/Light/Dim light",
      "values": {
        "hex": "#000000",
        "hexa": "#000000a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.04)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.04)",
        "alpha": 0.04
      }
    },
    {
      "name": "Overlay/Light/Picture dark",
      "values": {
        "hex": "#000000",
        "hexa": "#00000099",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.6)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Overlay/Light/Picture white",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF3",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.01)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.01)",
        "alpha": 0.01
      }
    },
    {
      "name": "Overlay/Light/Dim strong",
      "values": {
        "hex": "#000000",
        "hexa": "#00000066",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.4)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "Overlay/Light/Dim very light",
      "values": {
        "hex": "#000000",
        "hexa": "#0000008",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.03)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.03)",
        "alpha": 0.03
      }
    },
    {
      "name": "Overlay/Light/Soften",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF4d",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.3)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Overlay/Light/Tile dim strong",
      "values": {
        "hex": "#F8F8F8",
        "hexa": "#F8F8F8cc",
        "rgb": "rgb(248, 248, 248)",
        "rgba": "rgba(248, 248, 248, 0.8)",
        "hsl": "hsl(0, 0%, 97%)",
        "hsla": "hsl(0, 0%, 97%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Overlay/Light/Text Area On Picture",
      "values": {
        "hex": "#999999",
        "hexa": "#999999e6",
        "rgb": "rgb(153, 153, 153)",
        "rgba": "rgba(153, 153, 153, 0.9)",
        "hsl": "hsl(0, 0%, 60%)",
        "hsla": "hsl(0, 0%, 60%, 0.9)",
        "alpha": 0.9
      }
    },
    {
      "name": "Overlay/Light/Picture Default",
      "values": {
        "hex": "#000000",
        "hexa": "#000000a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.04)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.04)",
        "alpha": 0.04
      }
    },
    {
      "name": "Overlay/Light/Dim moderate",
      "values": {
        "hex": "#000000",
        "hexa": "#00000033",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.2)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Overlay/Light/Secondary Chart",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF99",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.6)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Overlay/Light/Dim for modal",
      "values": {
        "hex": "#000000",
        "hexa": "#00000033",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.2)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Overlay/Light/Dim very strong",
      "values": {
        "hex": "#000000",
        "hexa": "#00000099",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.6)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Overlay/Light/Soften Strong",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFb3",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.7)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Overlay/Dark/Dim light",
      "values": {
        "hex": "#000000",
        "hexa": "#00000033",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.2)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Overlay/Dark/Picture dark",
      "values": {
        "hex": "#000000",
        "hexa": "#000000cc",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.8)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Overlay/Dark/Picture white",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF26",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.15)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.15)",
        "alpha": 0.15
      }
    },
    {
      "name": "Overlay/Dark/Dim strong",
      "values": {
        "hex": "#000000",
        "hexa": "#000000b3",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.7)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Overlay/Dark/Dim very light",
      "values": {
        "hex": "#000000",
        "hexa": "#000000a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.04)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.04)",
        "alpha": 0.04
      }
    },
    {
      "name": "Overlay/Dark/Soften",
      "values": {
        "hex": "#000000",
        "hexa": "#0000004d",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.3)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Overlay/Dark/Tile dim strong",
      "values": {
        "hex": "#272727",
        "hexa": "#272727cc",
        "rgb": "rgb(39, 39, 39)",
        "rgba": "rgba(39, 39, 39, 0.8)",
        "hsl": "hsl(0, 0%, 15%)",
        "hsla": "hsl(0, 0%, 15%, 0.8)",
        "alpha": 0.8
      }
    },
    {
      "name": "Overlay/Dark/Text Area On Picture",
      "values": {
        "hex": "#999999",
        "hexa": "#999999e6",
        "rgb": "rgb(153, 153, 153)",
        "rgba": "rgba(153, 153, 153, 0.9)",
        "hsl": "hsl(0, 0%, 60%)",
        "hsla": "hsl(0, 0%, 60%, 0.9)",
        "alpha": 0.9
      }
    },
    {
      "name": "Overlay/Dark/Picture Default",
      "values": {
        "hex": "#000000",
        "hexa": "#0000001a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Overlay/Dark/Dim moderate",
      "values": {
        "hex": "#000000",
        "hexa": "#0000004d",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.3)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Overlay/Dark/Secondary Chart",
      "values": {
        "hex": "#000000",
        "hexa": "#00000099",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.6)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Overlay/Dark/Dim for modal",
      "values": {
        "hex": "#000000",
        "hexa": "#000000b3",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.7)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Overlay/Dark/Dim very strong",
      "values": {
        "hex": "#000000",
        "hexa": "#000000e6",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.9)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.9)",
        "alpha": 0.9
      }
    },
    {
      "name": "Overlay/Dark/Soften Strong",
      "values": {
        "hex": "#000000",
        "hexa": "#000000b3",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.7)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Fader/Light/Test",
      "values": {
        "hex": "#C4C4C4",
        "hexa": "#C4C4C4ff",
        "rgb": "rgb(196, 196, 196)",
        "rgba": "rgba(196, 196, 196, 1)",
        "hsl": "hsl(0, 0%, 77%)",
        "hsla": "hsl(0, 0%, 77%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Light/Selected",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Light/Selected Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Light/Unselected",
      "values": {
        "hex": "#000000",
        "hexa": "#0000000",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Filter/Light/Unselected Text",
      "values": {
        "hex": "#404045",
        "hexa": "#404045ff",
        "rgb": "rgb(64, 64, 69)",
        "rgba": "rgba(64, 64, 69, 1)",
        "hsl": "hsl(240, 4%, 26%)",
        "hsla": "hsl(240, 4%, 26%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Light/Hover",
      "values": {
        "hex": "#000000",
        "hexa": "#00000014",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.08)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.08)",
        "alpha": 0.08
      }
    },
    {
      "name": "Filter/Light/Hover Text",
      "values": {
        "hex": "#2B2901",
        "hexa": "#2B2901ff",
        "rgb": "rgb(43, 41, 1)",
        "rgba": "rgba(43, 41, 1, 1)",
        "hsl": "hsl(57, 95%, 9%)",
        "hsla": "hsl(57, 95%, 9%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Light/Hairline",
      "values": {
        "hex": "#E3E3E3",
        "hexa": "#E3E3E3ff",
        "rgb": "rgb(227, 227, 227)",
        "rgba": "rgba(227, 227, 227, 1)",
        "hsl": "hsl(0, 0%, 89%)",
        "hsla": "hsl(0, 0%, 89%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Dark/Selected",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Dark/Selected Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Dark/Unselected",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF0",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Filter/Dark/Unselected Text",
      "values": {
        "hex": "#B4B4B4",
        "hexa": "#B4B4B4ff",
        "rgb": "rgb(180, 180, 180)",
        "rgba": "rgba(180, 180, 180, 1)",
        "hsl": "hsl(0, 0%, 71%)",
        "hsla": "hsl(0, 0%, 71%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Dark/Hover",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1f",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.12)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.12)",
        "alpha": 0.12
      }
    },
    {
      "name": "Filter/Dark/Hover Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Filter/Dark/Hairline",
      "values": {
        "hex": "#454442",
        "hexa": "#4544420",
        "rgb": "rgb(69, 68, 66)",
        "rgba": "rgba(69, 68, 66, 0)",
        "hsl": "hsl(40, 2%, 26%)",
        "hsla": "hsl(40, 2%, 26%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Status/Light/Active",
      "values": {
        "hex": "#65C366",
        "hexa": "#65C366ff",
        "rgb": "rgb(101, 195, 102)",
        "rgba": "rgba(101, 195, 102, 1)",
        "hsl": "hsl(121, 44%, 58%)",
        "hsla": "hsl(121, 44%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Active hatch",
      "values": {
        "hex": "#6ED16F",
        "hexa": "#6ED16Fff",
        "rgb": "rgb(110, 209, 111)",
        "rgba": "rgba(110, 209, 111, 1)",
        "hsl": "hsl(121, 52%, 63%)",
        "hsla": "hsl(121, 52%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Active previous period",
      "values": {
        "hex": "#AEAEB2",
        "hexa": "#AEAEB2ff",
        "rgb": "rgb(174, 174, 178)",
        "rgba": "rgba(174, 174, 178, 1)",
        "hsl": "hsl(240, 3%, 69%)",
        "hsla": "hsl(240, 3%, 69%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Change",
      "values": {
        "hex": "#FF9500",
        "hexa": "#FF9500ff",
        "rgb": "rgb(255, 149, 0)",
        "rgba": "rgba(255, 149, 0, 1)",
        "hsl": "hsl(35, 100%, 50%)",
        "hsla": "hsl(35, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Change hatch",
      "values": {
        "hex": "#FFAD24",
        "hexa": "#FFAD24ff",
        "rgb": "rgb(255, 173, 36)",
        "rgba": "rgba(255, 173, 36, 1)",
        "hsl": "hsl(38, 100%, 57%)",
        "hsla": "hsl(38, 100%, 57%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Change previous period",
      "values": {
        "hex": "#FFCA80",
        "hexa": "#FFCA80ff",
        "rgb": "rgb(255, 202, 128)",
        "rgba": "rgba(255, 202, 128, 1)",
        "hsl": "hsl(35, 100%, 75%)",
        "hsla": "hsl(35, 100%, 75%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Setup",
      "values": {
        "hex": "#E040FB",
        "hexa": "#E040FBff",
        "rgb": "rgb(224, 64, 251)",
        "rgba": "rgba(224, 64, 251, 1)",
        "hsl": "hsl(291, 96%, 62%)",
        "hsla": "hsl(291, 96%, 62%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Setup background",
      "values": {
        "hex": "#FBE8FF",
        "hexa": "#FBE8FFff",
        "rgb": "rgb(251, 232, 255)",
        "rgba": "rgba(251, 232, 255, 1)",
        "hsl": "hsl(290, 100%, 95%)",
        "hsla": "hsl(290, 100%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Setup hatch",
      "values": {
        "hex": "#E868FF",
        "hexa": "#E868FFff",
        "rgb": "rgb(232, 104, 255)",
        "rgba": "rgba(232, 104, 255, 1)",
        "hsl": "hsl(291, 100%, 70%)",
        "hsla": "hsl(291, 100%, 70%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Setup previous period",
      "values": {
        "hex": "#EF9FFD",
        "hexa": "#EF9FFDff",
        "rgb": "rgb(239, 159, 253)",
        "rgba": "rgba(239, 159, 253, 1)",
        "hsl": "hsl(291, 96%, 81%)",
        "hsla": "hsl(291, 96%, 81%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Productive",
      "values": {
        "hex": "#2DA0FC",
        "hexa": "#2DA0FCff",
        "rgb": "rgb(45, 160, 252)",
        "rgba": "rgba(45, 160, 252, 1)",
        "hsl": "hsl(207, 97%, 58%)",
        "hsla": "hsl(207, 97%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Productive background",
      "values": {
        "hex": "#E0F1FF",
        "hexa": "#E0F1FFff",
        "rgb": "rgb(224, 241, 255)",
        "rgba": "rgba(224, 241, 255, 1)",
        "hsl": "hsl(207, 100%, 94%)",
        "hsla": "hsl(207, 100%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Productive hatch",
      "values": {
        "hex": "#86D8FD",
        "hexa": "#86D8FDff",
        "rgb": "rgb(134, 216, 253)",
        "rgba": "rgba(134, 216, 253, 1)",
        "hsl": "hsl(199, 97%, 76%)",
        "hsla": "hsl(199, 97%, 76%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Productive previous period",
      "values": {
        "hex": "#AEAEB2",
        "hexa": "#AEAEB2ff",
        "rgb": "rgb(174, 174, 178)",
        "rgba": "rgba(174, 174, 178, 1)",
        "hsl": "hsl(240, 3%, 69%)",
        "hsla": "hsl(240, 3%, 69%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Paid",
      "values": {
        "hex": "#3634A3",
        "hexa": "#3634A3ff",
        "rgb": "rgb(54, 52, 163)",
        "rgba": "rgba(54, 52, 163, 1)",
        "hsl": "hsl(241, 52%, 42%)",
        "hsla": "hsl(241, 52%, 42%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Paid hatch",
      "values": {
        "hex": "#7271BF",
        "hexa": "#7271BFff",
        "rgb": "rgb(114, 113, 191)",
        "rgba": "rgba(114, 113, 191, 1)",
        "hsl": "hsl(241, 38%, 60%)",
        "hsla": "hsl(241, 38%, 60%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Paid previous period",
      "values": {
        "hex": "#C3C2E3",
        "hexa": "#C3C2E3ff",
        "rgb": "rgb(195, 194, 227)",
        "rgba": "rgba(195, 194, 227, 1)",
        "hsl": "hsl(242, 37%, 83%)",
        "hsla": "hsl(242, 37%, 83%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Not Productive",
      "values": {
        "hex": "#8A8A94",
        "hexa": "#8A8A94ff",
        "rgb": "rgb(138, 138, 148)",
        "rgba": "rgba(138, 138, 148, 1)",
        "hsl": "hsl(240, 4%, 56%)",
        "hsla": "hsl(240, 4%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Missing",
      "values": {
        "hex": "#FFCC00",
        "hexa": "#FFCC00ff",
        "rgb": "rgb(255, 204, 0)",
        "rgba": "rgba(255, 204, 0, 1)",
        "hsl": "hsl(48, 100%, 50%)",
        "hsla": "hsl(48, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Active tertiary",
      "values": {
        "hex": "#CFEFCF",
        "hexa": "#CFEFCFff",
        "rgb": "rgb(207, 239, 207)",
        "rgba": "rgba(207, 239, 207, 1)",
        "hsl": "hsl(120, 50%, 87%)",
        "hsla": "hsl(120, 50%, 87%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Change tertiary",
      "values": {
        "hex": "#FFEACC",
        "hexa": "#FFEACCff",
        "rgb": "rgb(255, 234, 204)",
        "rgba": "rgba(255, 234, 204, 1)",
        "hsl": "hsl(35, 100%, 90%)",
        "hsla": "hsl(35, 100%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Setup tertiary",
      "values": {
        "hex": "#EF9FFD",
        "hexa": "#EF9FFDff",
        "rgb": "rgb(239, 159, 253)",
        "rgba": "rgba(239, 159, 253, 1)",
        "hsl": "hsl(291, 96%, 81%)",
        "hsla": "hsl(291, 96%, 81%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Productive tertiary",
      "values": {
        "hex": "#96CFFD",
        "hexa": "#96CFFDff",
        "rgb": "rgb(150, 207, 253)",
        "rgba": "rgba(150, 207, 253, 1)",
        "hsl": "hsl(207, 96%, 79%)",
        "hsla": "hsl(207, 96%, 79%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Not Productive tertiary",
      "values": {
        "hex": "#B9BFBF",
        "hexa": "#B9BFBFff",
        "rgb": "rgb(185, 191, 191)",
        "rgba": "rgba(185, 191, 191, 1)",
        "hsl": "hsl(180, 4%, 74%)",
        "hsla": "hsl(180, 4%, 74%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Active on Selected",
      "values": {
        "hex": "#0AEA42",
        "hexa": "#0AEA42ff",
        "rgb": "rgb(10, 234, 66)",
        "rgba": "rgba(10, 234, 66, 1)",
        "hsl": "hsl(135, 92%, 48%)",
        "hsla": "hsl(135, 92%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Paid On Selected",
      "values": {
        "hex": "#06039E",
        "hexa": "#06039Eff",
        "rgb": "rgb(6, 3, 158)",
        "rgba": "rgba(6, 3, 158, 1)",
        "hsl": "hsl(241, 96%, 32%)",
        "hsla": "hsl(241, 96%, 32%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Productive previous period On Selected",
      "values": {
        "hex": "#C6C6C6",
        "hexa": "#C6C6C6ff",
        "rgb": "rgb(198, 198, 198)",
        "rgba": "rgba(198, 198, 198, 1)",
        "hsl": "hsl(0, 0%, 78%)",
        "hsla": "hsl(0, 0%, 78%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Productive On Selected",
      "values": {
        "hex": "#96CFFD",
        "hexa": "#96CFFDff",
        "rgb": "rgb(150, 207, 253)",
        "rgba": "rgba(150, 207, 253, 1)",
        "hsl": "hsl(207, 96%, 79%)",
        "hsla": "hsl(207, 96%, 79%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Paid previous period On Selected",
      "values": {
        "hex": "#D8D7F3",
        "hexa": "#D8D7F3ff",
        "rgb": "rgb(216, 215, 243)",
        "rgba": "rgba(216, 215, 243, 1)",
        "hsl": "hsl(242, 54%, 90%)",
        "hsla": "hsl(242, 54%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Active previous period On Selected",
      "values": {
        "hex": "#AEAEB2",
        "hexa": "#AEAEB2ff",
        "rgb": "rgb(174, 174, 178)",
        "rgba": "rgba(174, 174, 178, 1)",
        "hsl": "hsl(240, 3%, 69%)",
        "hsla": "hsl(240, 3%, 69%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Active hover",
      "values": {
        "hex": "#83CE84",
        "hexa": "#83CE84ff",
        "rgb": "rgb(131, 206, 132)",
        "rgba": "rgba(131, 206, 132, 1)",
        "hsl": "hsl(121, 43%, 66%)",
        "hsla": "hsl(121, 43%, 66%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Active pressed",
      "values": {
        "hex": "#65C366",
        "hexa": "#65C366b3",
        "rgb": "rgb(101, 195, 102)",
        "rgba": "rgba(101, 195, 102, 0.7)",
        "hsl": "hsl(121, 44%, 58%)",
        "hsla": "hsl(121, 44%, 58%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Status/Light/Active quaternary",
      "values": {
        "hex": "#E7F7E7",
        "hexa": "#E7F7E7ff",
        "rgb": "rgb(231, 247, 231)",
        "rgba": "rgba(231, 247, 231, 1)",
        "hsl": "hsl(120, 50%, 94%)",
        "hsla": "hsl(120, 50%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Change quaternary",
      "values": {
        "hex": "#FFF5E5",
        "hexa": "#FFF5E5ff",
        "rgb": "rgb(255, 245, 229)",
        "rgba": "rgba(255, 245, 229, 1)",
        "hsl": "hsl(37, 100%, 95%)",
        "hsla": "hsl(37, 100%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Setup quaternary",
      "values": {
        "hex": "#F7CFFE",
        "hexa": "#F7CFFEff",
        "rgb": "rgb(247, 207, 254)",
        "rgba": "rgba(247, 207, 254, 1)",
        "hsl": "hsl(291, 96%, 90%)",
        "hsla": "hsl(291, 96%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Light/Not Productive quaternary",
      "values": {
        "hex": "#EAECEC",
        "hexa": "#EAECECff",
        "rgb": "rgb(234, 236, 236)",
        "rgba": "rgba(234, 236, 236, 1)",
        "hsl": "hsl(180, 5%, 92%)",
        "hsla": "hsl(180, 5%, 92%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active",
      "values": {
        "hex": "#30D158",
        "hexa": "#30D158ff",
        "rgb": "rgb(48, 209, 88)",
        "rgba": "rgba(48, 209, 88, 1)",
        "hsl": "hsl(135, 64%, 50%)",
        "hsla": "hsl(135, 64%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active hatch",
      "values": {
        "hex": "#4CBD4E",
        "hexa": "#4CBD4Eff",
        "rgb": "rgb(76, 189, 78)",
        "rgba": "rgba(76, 189, 78, 1)",
        "hsl": "hsl(121, 46%, 52%)",
        "hsla": "hsl(121, 46%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active previous period",
      "values": {
        "hex": "#636366",
        "hexa": "#636366ff",
        "rgb": "rgb(99, 99, 102)",
        "rgba": "rgba(99, 99, 102, 1)",
        "hsl": "hsl(240, 1%, 39%)",
        "hsla": "hsl(240, 1%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Change",
      "values": {
        "hex": "#FF9F0A",
        "hexa": "#FF9F0Aff",
        "rgb": "rgb(255, 159, 10)",
        "rgba": "rgba(255, 159, 10, 1)",
        "hsl": "hsl(36, 100%, 52%)",
        "hsla": "hsl(36, 100%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Change hatch",
      "values": {
        "hex": "#EE9307",
        "hexa": "#EE9307ff",
        "rgb": "rgb(238, 147, 7)",
        "rgba": "rgba(238, 147, 7, 1)",
        "hsl": "hsl(36, 94%, 48%)",
        "hsla": "hsl(36, 94%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Change previous period",
      "values": {
        "hex": "#956519",
        "hexa": "#956519ff",
        "rgb": "rgb(149, 101, 25)",
        "rgba": "rgba(149, 101, 25, 1)",
        "hsl": "hsl(37, 71%, 34%)",
        "hsla": "hsl(37, 71%, 34%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Setup",
      "values": {
        "hex": "#BF5AF2",
        "hexa": "#BF5AF2ff",
        "rgb": "rgb(191, 90, 242)",
        "rgba": "rgba(191, 90, 242, 1)",
        "hsl": "hsl(280, 85%, 65%)",
        "hsla": "hsl(280, 85%, 65%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Setup hatch",
      "values": {
        "hex": "#B24FE4",
        "hexa": "#B24FE4ff",
        "rgb": "rgb(178, 79, 228)",
        "rgba": "rgba(178, 79, 228, 1)",
        "hsl": "hsl(280, 73%, 60%)",
        "hsla": "hsl(280, 73%, 60%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Setup previous period",
      "values": {
        "hex": "#76428D",
        "hexa": "#76428Dff",
        "rgb": "rgb(118, 66, 141)",
        "rgba": "rgba(118, 66, 141, 1)",
        "hsl": "hsl(282, 36%, 41%)",
        "hsla": "hsl(282, 36%, 41%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Productive",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Productive hatch",
      "values": {
        "hex": "#1C87DD",
        "hexa": "#1C87DDff",
        "rgb": "rgb(28, 135, 221)",
        "rgba": "rgba(28, 135, 221, 1)",
        "hsl": "hsl(207, 78%, 49%)",
        "hsla": "hsl(207, 78%, 49%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Productive previous period",
      "values": {
        "hex": "#636366",
        "hexa": "#636366ff",
        "rgb": "rgb(99, 99, 102)",
        "rgba": "rgba(99, 99, 102, 1)",
        "hsl": "hsl(240, 1%, 39%)",
        "hsla": "hsl(240, 1%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Paid",
      "values": {
        "hex": "#5C60DE",
        "hexa": "#5C60DEff",
        "rgb": "rgb(92, 96, 222)",
        "rgba": "rgba(92, 96, 222, 1)",
        "hsl": "hsl(238, 66%, 62%)",
        "hsla": "hsl(238, 66%, 62%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Paid hatch",
      "values": {
        "hex": "#4E50A7",
        "hexa": "#4E50A7ff",
        "rgb": "rgb(78, 80, 167)",
        "rgba": "rgba(78, 80, 167, 1)",
        "hsl": "hsl(239, 36%, 48%)",
        "hsla": "hsl(239, 36%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Paid previous period",
      "values": {
        "hex": "#3A3A5F",
        "hexa": "#3A3A5Fff",
        "rgb": "rgb(58, 58, 95)",
        "rgba": "rgba(58, 58, 95, 1)",
        "hsl": "hsl(240, 24%, 30%)",
        "hsla": "hsl(240, 24%, 30%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Not Productive",
      "values": {
        "hex": "#767680",
        "hexa": "#767680ff",
        "rgb": "rgb(118, 118, 128)",
        "rgba": "rgba(118, 118, 128, 1)",
        "hsl": "hsl(240, 4%, 48%)",
        "hsla": "hsl(240, 4%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Missing",
      "values": {
        "hex": "#FFD60A",
        "hexa": "#FFD60Aff",
        "rgb": "rgb(255, 214, 10)",
        "rgba": "rgba(255, 214, 10, 1)",
        "hsl": "hsl(50, 100%, 52%)",
        "hsla": "hsl(50, 100%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active tertiary",
      "values": {
        "hex": "#2D492D",
        "hexa": "#2D492Dff",
        "rgb": "rgb(45, 73, 45)",
        "rgba": "rgba(45, 73, 45, 1)",
        "hsl": "hsl(120, 24%, 23%)",
        "hsla": "hsl(120, 24%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Change tertiary",
      "values": {
        "hex": "#3F311C",
        "hexa": "#3F311Cff",
        "rgb": "rgb(63, 49, 28)",
        "rgba": "rgba(63, 49, 28, 1)",
        "hsl": "hsl(36, 38%, 18%)",
        "hsla": "hsl(36, 38%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Setup tertiary",
      "values": {
        "hex": "#3D2949",
        "hexa": "#3D2949ff",
        "rgb": "rgb(61, 41, 73)",
        "rgba": "rgba(61, 41, 73, 1)",
        "hsl": "hsl(278, 28%, 22%)",
        "hsla": "hsl(278, 28%, 22%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Productive tertiary",
      "values": {
        "hex": "#265D89",
        "hexa": "#265D89ff",
        "rgb": "rgb(38, 93, 137)",
        "rgba": "rgba(38, 93, 137, 1)",
        "hsl": "hsl(207, 57%, 34%)",
        "hsla": "hsl(207, 57%, 34%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Not Productive tertiary",
      "values": {
        "hex": "#514B54",
        "hexa": "#514B54ff",
        "rgb": "rgb(81, 75, 84)",
        "rgba": "rgba(81, 75, 84, 1)",
        "hsl": "hsl(280, 6%, 31%)",
        "hsla": "hsl(280, 6%, 31%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active on Selected",
      "values": {
        "hex": "#0AEA42",
        "hexa": "#0AEA42ff",
        "rgb": "rgb(10, 234, 66)",
        "rgba": "rgba(10, 234, 66, 1)",
        "hsl": "hsl(135, 92%, 48%)",
        "hsla": "hsl(135, 92%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Paid On Selected",
      "values": {
        "hex": "#4247DC",
        "hexa": "#4247DCff",
        "rgb": "rgb(66, 71, 220)",
        "rgba": "rgba(66, 71, 220, 1)",
        "hsl": "hsl(238, 69%, 56%)",
        "hsla": "hsl(238, 69%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Productive previous period On Selected",
      "values": {
        "hex": "#C6C6C6",
        "hexa": "#C6C6C6ff",
        "rgb": "rgb(198, 198, 198)",
        "rgba": "rgba(198, 198, 198, 1)",
        "hsl": "hsl(0, 0%, 78%)",
        "hsla": "hsl(0, 0%, 78%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Productive On Selected",
      "values": {
        "hex": "#A4D6FF",
        "hexa": "#A4D6FFff",
        "rgb": "rgb(164, 214, 255)",
        "rgba": "rgba(164, 214, 255, 1)",
        "hsl": "hsl(207, 100%, 82%)",
        "hsla": "hsl(207, 100%, 82%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Paid previous period On Selected",
      "values": {
        "hex": "#BFBFD2",
        "hexa": "#BFBFD2ff",
        "rgb": "rgb(191, 191, 210)",
        "rgba": "rgba(191, 191, 210, 1)",
        "hsl": "hsl(240, 17%, 79%)",
        "hsla": "hsl(240, 17%, 79%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active previous period On Selected",
      "values": {
        "hex": "#636366",
        "hexa": "#636366ff",
        "rgb": "rgb(99, 99, 102)",
        "rgba": "rgba(99, 99, 102, 1)",
        "hsl": "hsl(240, 1%, 39%)",
        "hsla": "hsl(240, 1%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active hover",
      "values": {
        "hex": "#2BAC4C",
        "hexa": "#2BAC4Cff",
        "rgb": "rgb(43, 172, 76)",
        "rgba": "rgba(43, 172, 76, 1)",
        "hsl": "hsl(135, 60%, 42%)",
        "hsla": "hsl(135, 60%, 42%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Active pressed",
      "values": {
        "hex": "#30D158",
        "hexa": "#30D158b3",
        "rgb": "rgb(48, 209, 88)",
        "rgba": "rgba(48, 209, 88, 0.7)",
        "hsl": "hsl(135, 64%, 50%)",
        "hsla": "hsl(135, 64%, 50%, 0.7)",
        "alpha": 0.7
      }
    },
    {
      "name": "Status/Dark/Active quaternary",
      "values": {
        "hex": "#2D3A2B",
        "hexa": "#2D3A2Bff",
        "rgb": "rgb(45, 58, 43)",
        "rgba": "rgba(45, 58, 43, 1)",
        "hsl": "hsl(112, 15%, 20%)",
        "hsla": "hsl(112, 15%, 20%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Change quaternary",
      "values": {
        "hex": "#362E22",
        "hexa": "#362E22ff",
        "rgb": "rgb(54, 46, 34)",
        "rgba": "rgba(54, 46, 34, 1)",
        "hsl": "hsl(36, 23%, 17%)",
        "hsla": "hsl(36, 23%, 17%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Setup quaternary",
      "values": {
        "hex": "#352A39",
        "hexa": "#352A39ff",
        "rgb": "rgb(53, 42, 57)",
        "rgba": "rgba(53, 42, 57, 1)",
        "hsl": "hsl(284, 15%, 19%)",
        "hsla": "hsl(284, 15%, 19%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Status/Dark/Not Productive quaternary",
      "values": {
        "hex": "#373435",
        "hexa": "#373435ff",
        "rgb": "rgb(55, 52, 53)",
        "rgba": "rgba(55, 52, 53, 1)",
        "hsl": "hsl(340, 3%, 21%)",
        "hsla": "hsl(340, 3%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Change",
      "values": {
        "hex": "#8B4E0B",
        "hexa": "#8B4E0Bff",
        "rgb": "rgb(139, 78, 11)",
        "rgba": "rgba(139, 78, 11, 1)",
        "hsl": "hsl(31, 85%, 29%)",
        "hsla": "hsl(31, 85%, 29%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Setup",
      "values": {
        "hex": "#44054F",
        "hexa": "#44054Fff",
        "rgb": "rgb(68, 5, 79)",
        "rgba": "rgba(68, 5, 79, 1)",
        "hsl": "hsl(291, 88%, 16%)",
        "hsla": "hsl(291, 88%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Not Productive",
      "values": {
        "hex": "#2E2E2E",
        "hexa": "#2E2E2Eff",
        "rgb": "rgb(46, 46, 46)",
        "rgba": "rgba(46, 46, 46, 1)",
        "hsl": "hsl(0, 0%, 18%)",
        "hsla": "hsl(0, 0%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Active",
      "values": {
        "hex": "#156228",
        "hexa": "#156228ff",
        "rgb": "rgb(21, 98, 40)",
        "rgba": "rgba(21, 98, 40, 1)",
        "hsl": "hsl(135, 65%, 23%)",
        "hsla": "hsl(135, 65%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Production Information Missing",
      "values": {
        "hex": "#9C433A",
        "hexa": "#9C433Aff",
        "rgb": "rgb(156, 67, 58)",
        "rgba": "rgba(156, 67, 58, 1)",
        "hsl": "hsl(6, 46%, 42%)",
        "hsla": "hsl(6, 46%, 42%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Missing",
      "values": {
        "hex": "#F6CF47",
        "hexa": "#F6CF47ff",
        "rgb": "rgb(246, 207, 71)",
        "rgba": "rgba(246, 207, 71, 1)",
        "hsl": "hsl(47, 91%, 62%)",
        "hsla": "hsl(47, 91%, 62%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Accent 1",
      "values": {
        "hex": "#000000",
        "hexa": "#00000033",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.2)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Panel/Light/Accent 2",
      "values": {
        "hex": "#000000",
        "hexa": "#00000066",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.4)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "Panel/Light/Accent 3",
      "values": {
        "hex": "#000000",
        "hexa": "#00000080",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.5)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Panel/Light/Accent 4",
      "values": {
        "hex": "#000000",
        "hexa": "#00000099",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.6)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.6)",
        "alpha": 0.6
      }
    },
    {
      "name": "Panel/Light/Off",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Light/Break",
      "values": {
        "hex": "#7CCDDB",
        "hexa": "#7CCDDBff",
        "rgb": "rgb(124, 205, 219)",
        "rgba": "rgba(124, 205, 219, 1)",
        "hsl": "hsl(189, 57%, 67%)",
        "hsla": "hsl(189, 57%, 67%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Change",
      "values": {
        "hex": "#8B4E0B",
        "hexa": "#8B4E0Bff",
        "rgb": "rgb(139, 78, 11)",
        "rgba": "rgba(139, 78, 11, 1)",
        "hsl": "hsl(31, 85%, 29%)",
        "hsla": "hsl(31, 85%, 29%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Setup",
      "values": {
        "hex": "#44054F",
        "hexa": "#44054Fff",
        "rgb": "rgb(68, 5, 79)",
        "rgba": "rgba(68, 5, 79, 1)",
        "hsl": "hsl(291, 88%, 16%)",
        "hsla": "hsl(291, 88%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Not Productive",
      "values": {
        "hex": "#262626",
        "hexa": "#262626ff",
        "rgb": "rgb(38, 38, 38)",
        "rgba": "rgba(38, 38, 38, 1)",
        "hsl": "hsl(0, 0%, 15%)",
        "hsla": "hsl(0, 0%, 15%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Active",
      "values": {
        "hex": "#156228",
        "hexa": "#156228ff",
        "rgb": "rgb(21, 98, 40)",
        "rgba": "rgba(21, 98, 40, 1)",
        "hsl": "hsl(135, 65%, 23%)",
        "hsla": "hsl(135, 65%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Production Information Missing",
      "values": {
        "hex": "#9C433A",
        "hexa": "#9C433Aff",
        "rgb": "rgb(156, 67, 58)",
        "rgba": "rgba(156, 67, 58, 1)",
        "hsl": "hsl(6, 46%, 42%)",
        "hsla": "hsl(6, 46%, 42%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Missing",
      "values": {
        "hex": "#F6CF47",
        "hexa": "#F6CF47ff",
        "rgb": "rgb(246, 207, 71)",
        "rgba": "rgba(246, 207, 71, 1)",
        "hsl": "hsl(47, 91%, 62%)",
        "hsla": "hsl(47, 91%, 62%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Accent 1",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF1a",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Panel/Dark/Accent 2",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF33",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.2)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Panel/Dark/Accent 3",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF4d",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.3)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Panel/Dark/Accent 4",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF66",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.4)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "Panel/Dark/Off",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Panel/Dark/Break",
      "values": {
        "hex": "#0B5461",
        "hexa": "#0B5461ff",
        "rgb": "rgb(11, 84, 97)",
        "rgba": "rgba(11, 84, 97, 1)",
        "hsl": "hsl(189, 80%, 21%)",
        "hsla": "hsl(189, 80%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Light/Selected Tile",
      "values": {
        "hex": "#E2EAF9",
        "hexa": "#E2EAF9ff",
        "rgb": "rgb(226, 234, 249)",
        "rgba": "rgba(226, 234, 249, 1)",
        "hsl": "hsl(219, 66%, 93%)",
        "hsla": "hsl(219, 66%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Light/Selected Row",
      "values": {
        "hex": "#AEBEDE",
        "hexa": "#AEBEDEff",
        "rgb": "rgb(174, 190, 222)",
        "rgba": "rgba(174, 190, 222, 1)",
        "hsl": "hsl(220, 42%, 78%)",
        "hsla": "hsl(220, 42%, 78%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Light/Logo/Smart",
      "values": {
        "hex": "#E51D73",
        "hexa": "#E51D73ff",
        "rgb": "rgb(229, 29, 115)",
        "rgba": "rgba(229, 29, 115, 1)",
        "hsl": "hsl(334, 79%, 51%)",
        "hsla": "hsl(334, 79%, 51%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Light/Logo/Factory",
      "values": {
        "hex": "#140C2C",
        "hexa": "#140C2Cff",
        "rgb": "rgb(20, 12, 44)",
        "rgba": "rgba(20, 12, 44, 1)",
        "hsl": "hsl(255, 57%, 11%)",
        "hsla": "hsl(255, 57%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Dark/Selected Tile",
      "values": {
        "hex": "#283041",
        "hexa": "#283041ff",
        "rgb": "rgb(40, 48, 65)",
        "rgba": "rgba(40, 48, 65, 1)",
        "hsl": "hsl(221, 24%, 21%)",
        "hsla": "hsl(221, 24%, 21%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Dark/Selected Row",
      "values": {
        "hex": "#2E3C59",
        "hexa": "#2E3C59ff",
        "rgb": "rgb(46, 60, 89)",
        "rgba": "rgba(46, 60, 89, 1)",
        "hsl": "hsl(220, 32%, 26%)",
        "hsla": "hsl(220, 32%, 26%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Dark/Logo/Smart",
      "values": {
        "hex": "#C02064",
        "hexa": "#C02064ff",
        "rgb": "rgb(192, 32, 100)",
        "rgba": "rgba(192, 32, 100, 1)",
        "hsl": "hsl(335, 71%, 44%)",
        "hsla": "hsl(335, 71%, 44%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Other/Dark/Logo/Factory",
      "values": {
        "hex": "#B0ACBC",
        "hexa": "#B0ACBCff",
        "rgb": "rgb(176, 172, 188)",
        "rgba": "rgba(176, 172, 188, 1)",
        "hsl": "hsl(255, 11%, 71%)",
        "hsla": "hsl(255, 11%, 71%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/1",
      "values": {
        "hex": "#8E8E93",
        "hexa": "#8E8E93ff",
        "rgb": "rgb(142, 142, 147)",
        "rgba": "rgba(142, 142, 147, 1)",
        "hsl": "hsl(240, 2%, 57%)",
        "hsla": "hsl(240, 2%, 57%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/2",
      "values": {
        "hex": "#AEAEB2",
        "hexa": "#AEAEB2ff",
        "rgb": "rgb(174, 174, 178)",
        "rgba": "rgba(174, 174, 178, 1)",
        "hsl": "hsl(240, 3%, 69%)",
        "hsla": "hsl(240, 3%, 69%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/3",
      "values": {
        "hex": "#C7C7CC",
        "hexa": "#C7C7CCff",
        "rgb": "rgb(199, 199, 204)",
        "rgba": "rgba(199, 199, 204, 1)",
        "hsl": "hsl(240, 5%, 79%)",
        "hsla": "hsl(240, 5%, 79%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/4",
      "values": {
        "hex": "#D2D2D2",
        "hexa": "#D2D2D2ff",
        "rgb": "rgb(210, 210, 210)",
        "rgba": "rgba(210, 210, 210, 1)",
        "hsl": "hsl(0, 0%, 82%)",
        "hsla": "hsl(0, 0%, 82%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/5",
      "values": {
        "hex": "#EDEDED",
        "hexa": "#EDEDEDff",
        "rgb": "rgb(237, 237, 237)",
        "rgba": "rgba(237, 237, 237, 1)",
        "hsl": "hsl(0, 0%, 93%)",
        "hsla": "hsl(0, 0%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/6",
      "values": {
        "hex": "#F4F4F5",
        "hexa": "#F4F4F5ff",
        "rgb": "rgb(244, 244, 245)",
        "rgba": "rgba(244, 244, 245, 1)",
        "hsl": "hsl(240, 5%, 96%)",
        "hsla": "hsl(240, 5%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/7",
      "values": {
        "hex": "#F9F9FA",
        "hexa": "#F9F9FAff",
        "rgb": "rgb(249, 249, 250)",
        "rgba": "rgba(249, 249, 250, 1)",
        "hsl": "hsl(240, 9%, 98%)",
        "hsla": "hsl(240, 9%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/0",
      "values": {
        "hex": "#5E5E64",
        "hexa": "#5E5E64ff",
        "rgb": "rgb(94, 94, 100)",
        "rgba": "rgba(94, 94, 100, 1)",
        "hsl": "hsl(240, 3%, 38%)",
        "hsla": "hsl(240, 3%, 38%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Light/4-7",
      "values": {
        "hex": "#E8E8E8",
        "hexa": "#E8E8E8ff",
        "rgb": "rgb(232, 232, 232)",
        "rgba": "rgba(232, 232, 232, 1)",
        "hsl": "hsl(0, 0%, 91%)",
        "hsla": "hsl(0, 0%, 91%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/1",
      "values": {
        "hex": "#8E8E93",
        "hexa": "#8E8E93ff",
        "rgb": "rgb(142, 142, 147)",
        "rgba": "rgba(142, 142, 147, 1)",
        "hsl": "hsl(240, 2%, 57%)",
        "hsla": "hsl(240, 2%, 57%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/2",
      "values": {
        "hex": "#636366",
        "hexa": "#636366ff",
        "rgb": "rgb(99, 99, 102)",
        "rgba": "rgba(99, 99, 102, 1)",
        "hsl": "hsl(240, 1%, 39%)",
        "hsla": "hsl(240, 1%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/3",
      "values": {
        "hex": "#48484A",
        "hexa": "#48484Aff",
        "rgb": "rgb(72, 72, 74)",
        "rgba": "rgba(72, 72, 74, 1)",
        "hsl": "hsl(240, 1%, 29%)",
        "hsla": "hsl(240, 1%, 29%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/4",
      "values": {
        "hex": "#3A3A3C",
        "hexa": "#3A3A3Cff",
        "rgb": "rgb(58, 58, 60)",
        "rgba": "rgba(58, 58, 60, 1)",
        "hsl": "hsl(240, 2%, 23%)",
        "hsla": "hsl(240, 2%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/5",
      "values": {
        "hex": "#2C2C2E",
        "hexa": "#2C2C2Eff",
        "rgb": "rgb(44, 44, 46)",
        "rgba": "rgba(44, 44, 46, 1)",
        "hsl": "hsl(240, 2%, 18%)",
        "hsla": "hsl(240, 2%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/6",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/7",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/0",
      "values": {
        "hex": "#B6B6BA",
        "hexa": "#B6B6BAff",
        "rgb": "rgb(182, 182, 186)",
        "rgba": "rgba(182, 182, 186, 1)",
        "hsl": "hsl(240, 3%, 72%)",
        "hsla": "hsl(240, 3%, 72%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray/Dark/4-7",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Fill/Light/Primary",
      "values": {
        "hex": "#787880",
        "hexa": "#78788033",
        "rgb": "rgb(120, 120, 128)",
        "rgba": "rgba(120, 120, 128, 0.2)",
        "hsl": "hsl(240, 3%, 49%)",
        "hsla": "hsl(240, 3%, 49%, 0.2)",
        "alpha": 0.2
      }
    },
    {
      "name": "Fill/Light/Secondary",
      "values": {
        "hex": "#787880",
        "hexa": "#78788029",
        "rgb": "rgb(120, 120, 128)",
        "rgba": "rgba(120, 120, 128, 0.16)",
        "hsl": "hsl(240, 3%, 49%)",
        "hsla": "hsl(240, 3%, 49%, 0.16)",
        "alpha": 0.16
      }
    },
    {
      "name": "Fill/Light/Tertiary",
      "values": {
        "hex": "#767680",
        "hexa": "#76768024",
        "rgb": "rgb(118, 118, 128)",
        "rgba": "rgba(118, 118, 128, 0.14)",
        "hsl": "hsl(240, 4%, 48%)",
        "hsla": "hsl(240, 4%, 48%, 0.14)",
        "alpha": 0.14
      }
    },
    {
      "name": "Fill/Light/Quaternary",
      "values": {
        "hex": "#747480",
        "hexa": "#7474801f",
        "rgb": "rgb(116, 116, 128)",
        "rgba": "rgba(116, 116, 128, 0.12)",
        "hsl": "hsl(240, 5%, 48%)",
        "hsla": "hsl(240, 5%, 48%, 0.12)",
        "alpha": 0.12
      }
    },
    {
      "name": "Fill/Light/Highlight",
      "values": {
        "hex": "#E0EBFF",
        "hexa": "#E0EBFFff",
        "rgb": "rgb(224, 235, 255)",
        "rgba": "rgba(224, 235, 255, 1)",
        "hsl": "hsl(219, 100%, 94%)",
        "hsla": "hsl(219, 100%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Fill/Light/Quinary",
      "values": {
        "hex": "#747480",
        "hexa": "#747480a",
        "rgb": "rgb(116, 116, 128)",
        "rgba": "rgba(116, 116, 128, 0.04)",
        "hsl": "hsl(240, 5%, 48%)",
        "hsla": "hsl(240, 5%, 48%, 0.04)",
        "alpha": 0.04
      }
    },
    {
      "name": "Fill / Dark / Primary",
      "values": {
        "hex": "#787880",
        "hexa": "#7878805c",
        "rgb": "rgb(120, 120, 128)",
        "rgba": "rgba(120, 120, 128, 0.36)",
        "hsl": "hsl(240, 3%, 49%)",
        "hsla": "hsl(240, 3%, 49%, 0.36)",
        "alpha": 0.36
      }
    },
    {
      "name": "Fill / Dark / Secondary",
      "values": {
        "hex": "#787880",
        "hexa": "#78788052",
        "rgb": "rgb(120, 120, 128)",
        "rgba": "rgba(120, 120, 128, 0.32)",
        "hsl": "hsl(240, 3%, 49%)",
        "hsla": "hsl(240, 3%, 49%, 0.32)",
        "alpha": 0.32
      }
    },
    {
      "name": "Fill / Dark / Tertiary",
      "values": {
        "hex": "#767680",
        "hexa": "#7676803d",
        "rgb": "rgb(118, 118, 128)",
        "rgba": "rgba(118, 118, 128, 0.24)",
        "hsl": "hsl(240, 4%, 48%)",
        "hsla": "hsl(240, 4%, 48%, 0.24)",
        "alpha": 0.24
      }
    },
    {
      "name": "Fill/Dark/Quaternary",
      "values": {
        "hex": "#767680",
        "hexa": "#76768024",
        "rgb": "rgb(118, 118, 128)",
        "rgba": "rgba(118, 118, 128, 0.14)",
        "hsl": "hsl(240, 4%, 48%)",
        "hsla": "hsl(240, 4%, 48%, 0.14)",
        "alpha": 0.14
      }
    },
    {
      "name": "Fill/Dark/Highlight",
      "values": {
        "hex": "#485368",
        "hexa": "#485368ff",
        "rgb": "rgb(72, 83, 104)",
        "rgba": "rgba(72, 83, 104, 1)",
        "hsl": "hsl(219, 18%, 35%)",
        "hsla": "hsl(219, 18%, 35%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Fill/Dark/Quinary",
      "values": {
        "hex": "#767680",
        "hexa": "#767680a",
        "rgb": "rgb(118, 118, 128)",
        "rgba": "rgba(118, 118, 128, 0.04)",
        "hsl": "hsl(240, 4%, 48%)",
        "hsla": "hsl(240, 4%, 48%, 0.04)",
        "alpha": 0.04
      }
    },
    {
      "name": "Chart/Light/Warning expected",
      "values": {
        "hex": "#FFB5B5",
        "hexa": "#FFB5B5ff",
        "rgb": "rgb(255, 181, 181)",
        "rgba": "rgba(255, 181, 181, 1)",
        "hsl": "hsl(0, 100%, 85%)",
        "hsla": "hsl(0, 100%, 85%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Warning",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 82%, 58%)",
        "hsla": "hsl(5, 82%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Warning expected selected",
      "values": {
        "hex": "#3362CC",
        "hexa": "#3362CCff",
        "rgb": "rgb(51, 98, 204)",
        "rgba": "rgba(51, 98, 204, 1)",
        "hsl": "hsl(222, 60%, 50%)",
        "hsla": "hsl(222, 60%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Warning text selected",
      "values": {
        "hex": "#FF8080",
        "hexa": "#FF8080ff",
        "rgb": "rgb(255, 128, 128)",
        "rgba": "rgba(255, 128, 128, 1)",
        "hsl": "hsl(0, 100%, 75%)",
        "hsla": "hsl(0, 100%, 75%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Net Utilization",
      "values": {
        "hex": "#EE6EA5",
        "hexa": "#EE6EA5ff",
        "rgb": "rgb(238, 110, 165)",
        "rgba": "rgba(238, 110, 165, 1)",
        "hsl": "hsl(334, 79%, 68%)",
        "hsla": "hsl(334, 79%, 68%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Previous Period Line",
      "values": {
        "hex": "#C7C7CC",
        "hexa": "#C7C7CCff",
        "rgb": "rgb(199, 199, 204)",
        "rgba": "rgba(199, 199, 204, 1)",
        "hsl": "hsl(240, 5%, 79%)",
        "hsla": "hsl(240, 5%, 79%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Previous Period Text",
      "values": {
        "hex": "#AEAEB2",
        "hexa": "#AEAEB2ff",
        "rgb": "rgb(174, 174, 178)",
        "rgba": "rgba(174, 174, 178, 1)",
        "hsl": "hsl(240, 3%, 69%)",
        "hsla": "hsl(240, 3%, 69%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Axis Text",
      "values": {
        "hex": "#9E9EA1",
        "hexa": "#9E9EA1ff",
        "rgb": "rgb(158, 158, 161)",
        "rgba": "rgba(158, 158, 161, 1)",
        "hsl": "hsl(240, 2%, 63%)",
        "hsla": "hsl(240, 2%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Axis",
      "values": {
        "hex": "#D9D9D9",
        "hexa": "#D9D9D9ff",
        "rgb": "rgb(217, 217, 217)",
        "rgba": "rgba(217, 217, 217, 1)",
        "hsl": "hsl(0, 0%, 85%)",
        "hsla": "hsl(0, 0%, 85%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Major Tick",
      "values": {
        "hex": "#C7C7CC",
        "hexa": "#C7C7CCff",
        "rgb": "rgb(199, 199, 204)",
        "rgba": "rgba(199, 199, 204, 1)",
        "hsl": "hsl(240, 5%, 79%)",
        "hsla": "hsl(240, 5%, 79%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Minor Tick",
      "values": {
        "hex": "#EDEDED",
        "hexa": "#EDEDEDff",
        "rgb": "rgb(237, 237, 237)",
        "rgba": "rgba(237, 237, 237, 1)",
        "hsl": "hsl(0, 0%, 93%)",
        "hsla": "hsl(0, 0%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Light/Net Utilization On Selected",
      "values": {
        "hex": "#FF74B0",
        "hexa": "#FF74B0ff",
        "rgb": "rgb(255, 116, 176)",
        "rgba": "rgba(255, 116, 176, 1)",
        "hsl": "hsl(334, 100%, 73%)",
        "hsla": "hsl(334, 100%, 73%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart / Dark / Warning expected",
      "values": {
        "hex": "#F57366",
        "hexa": "#F57366bf",
        "rgb": "rgb(245, 115, 102)",
        "rgba": "rgba(245, 115, 102, 0.75)",
        "hsl": "hsl(5, 88%, 68%)",
        "hsla": "hsl(5, 88%, 68%, 0.75)",
        "alpha": 0.75
      }
    },
    {
      "name": "Chart / Dark / Warning",
      "values": {
        "hex": "#E85344",
        "hexa": "#E85344ff",
        "rgb": "rgb(232, 83, 68)",
        "rgba": "rgba(232, 83, 68, 1)",
        "hsl": "hsl(5, 78%, 59%)",
        "hsla": "hsl(5, 78%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart / Dark / Warning expected selected",
      "values": {
        "hex": "#335FB2",
        "hexa": "#335FB2ff",
        "rgb": "rgb(51, 95, 178)",
        "rgba": "rgba(51, 95, 178, 1)",
        "hsl": "hsl(219, 55%, 45%)",
        "hsla": "hsl(219, 55%, 45%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart / Dark / Warning text selected",
      "values": {
        "hex": "#FF8080",
        "hexa": "#FF8080ff",
        "rgb": "rgb(255, 128, 128)",
        "rgba": "rgba(255, 128, 128, 1)",
        "hsl": "hsl(0, 100%, 75%)",
        "hsla": "hsl(0, 100%, 75%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Net Utilization",
      "values": {
        "hex": "#C9447B",
        "hexa": "#C9447Bff",
        "rgb": "rgb(201, 68, 123)",
        "rgba": "rgba(201, 68, 123, 1)",
        "hsl": "hsl(335, 55%, 53%)",
        "hsla": "hsl(335, 55%, 53%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Previous Period Line",
      "values": {
        "hex": "#48484A",
        "hexa": "#48484Aff",
        "rgb": "rgb(72, 72, 74)",
        "rgba": "rgba(72, 72, 74, 1)",
        "hsl": "hsl(240, 1%, 29%)",
        "hsla": "hsl(240, 1%, 29%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Previous Period Text",
      "values": {
        "hex": "#636366",
        "hexa": "#636366ff",
        "rgb": "rgb(99, 99, 102)",
        "rgba": "rgba(99, 99, 102, 1)",
        "hsl": "hsl(240, 1%, 39%)",
        "hsla": "hsl(240, 1%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Axis Text",
      "values": {
        "hex": "#7E7D7E",
        "hexa": "#7E7D7Eff",
        "rgb": "rgb(126, 125, 126)",
        "rgba": "rgba(126, 125, 126, 1)",
        "hsl": "hsl(300, 0%, 49%)",
        "hsla": "hsl(300, 0%, 49%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Axis",
      "values": {
        "hex": "#504E4D",
        "hexa": "#504E4Dff",
        "rgb": "rgb(80, 78, 77)",
        "rgba": "rgba(80, 78, 77, 1)",
        "hsl": "hsl(20, 2%, 31%)",
        "hsla": "hsl(20, 2%, 31%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Major Tick",
      "values": {
        "hex": "#48484A",
        "hexa": "#48484Aff",
        "rgb": "rgb(72, 72, 74)",
        "rgba": "rgba(72, 72, 74, 1)",
        "hsl": "hsl(240, 1%, 29%)",
        "hsla": "hsl(240, 1%, 29%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Minor Tick",
      "values": {
        "hex": "#2C2C2E",
        "hexa": "#2C2C2Eff",
        "rgb": "rgb(44, 44, 46)",
        "rgba": "rgba(44, 44, 46, 1)",
        "hsl": "hsl(240, 2%, 18%)",
        "hsla": "hsl(240, 2%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Chart/Dark/Net Utilization On Selected",
      "values": {
        "hex": "#FF74B0",
        "hexa": "#FF74B0ff",
        "rgb": "rgb(255, 116, 176)",
        "rgba": "rgba(255, 116, 176, 1)",
        "hsl": "hsl(334, 100%, 73%)",
        "hsla": "hsl(334, 100%, 73%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Productive Tile",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Active",
      "values": {
        "hex": "#1D8436",
        "hexa": "#1D8436ff",
        "rgb": "rgb(29, 132, 54)",
        "rgba": "rgba(29, 132, 54, 1)",
        "hsl": "hsl(135, 64%, 32%)",
        "hsla": "hsl(135, 64%, 32%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Active hatch",
      "values": {
        "hex": "#4DCA6D",
        "hexa": "#4DCA6Dff",
        "rgb": "rgb(77, 202, 109)",
        "rgba": "rgba(77, 202, 109, 1)",
        "hsl": "hsl(135, 54%, 55%)",
        "hsla": "hsl(135, 54%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Change",
      "values": {
        "hex": "#DA7F00",
        "hexa": "#DA7F00ff",
        "rgb": "rgb(218, 127, 0)",
        "rgba": "rgba(218, 127, 0, 1)",
        "hsl": "hsl(35, 100%, 43%)",
        "hsla": "hsl(35, 100%, 43%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Change hatch",
      "values": {
        "hex": "#DA7F00",
        "hexa": "#DA7F00ff",
        "rgb": "rgb(218, 127, 0)",
        "rgba": "rgba(218, 127, 0, 1)",
        "hsl": "hsl(35, 100%, 43%)",
        "hsla": "hsl(35, 100%, 43%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Setup",
      "values": {
        "hex": "#CA34E3",
        "hexa": "#CA34E3ff",
        "rgb": "rgb(202, 52, 227)",
        "rgba": "rgba(202, 52, 227, 1)",
        "hsl": "hsl(291, 76%, 55%)",
        "hsla": "hsl(291, 76%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Setup hatch",
      "values": {
        "hex": "#CA34E3",
        "hexa": "#CA34E3ff",
        "rgb": "rgb(202, 52, 227)",
        "rgba": "rgba(202, 52, 227, 1)",
        "hsl": "hsl(291, 76%, 55%)",
        "hsla": "hsl(291, 76%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Not Productive",
      "values": {
        "hex": "#8A8A94",
        "hexa": "#8A8A94ff",
        "rgb": "rgb(138, 138, 148)",
        "rgba": "rgba(138, 138, 148, 1)",
        "hsl": "hsl(240, 4%, 56%)",
        "hsla": "hsl(240, 4%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Not Productive hatch",
      "values": {
        "hex": "#8A8A94",
        "hexa": "#8A8A94ff",
        "rgb": "rgb(138, 138, 148)",
        "rgba": "rgba(138, 138, 148, 1)",
        "hsl": "hsl(240, 4%, 56%)",
        "hsla": "hsl(240, 4%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Not Productive Tile",
      "values": {
        "hex": "#CECFD0",
        "hexa": "#CECFD0ff",
        "rgb": "rgb(206, 207, 208)",
        "rgba": "rgba(206, 207, 208, 1)",
        "hsl": "hsl(210, 2%, 81%)",
        "hsla": "hsl(210, 2%, 81%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Tile Hairline",
      "values": {
        "hex": "#8A8A8A",
        "hexa": "#8A8A8A80",
        "rgb": "rgb(138, 138, 138)",
        "rgba": "rgba(138, 138, 138, 0.5)",
        "hsl": "hsl(0, 0%, 54%)",
        "hsla": "hsl(0, 0%, 54%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "Wallboard/Light/Gauge OEE Poor",
      "values": {
        "hex": "#EC4D3D",
        "hexa": "#EC4D3Dff",
        "rgb": "rgb(236, 77, 61)",
        "rgba": "rgba(236, 77, 61, 1)",
        "hsl": "hsl(5, 82%, 58%)",
        "hsla": "hsl(5, 82%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Gauge OEE Fair",
      "values": {
        "hex": "#DA7F00",
        "hexa": "#DA7F00ff",
        "rgb": "rgb(218, 127, 0)",
        "rgba": "rgba(218, 127, 0, 1)",
        "hsl": "hsl(35, 100%, 43%)",
        "hsla": "hsl(35, 100%, 43%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Gauge OEE Good",
      "values": {
        "hex": "#4FBC6B",
        "hexa": "#4FBC6Bff",
        "rgb": "rgb(79, 188, 107)",
        "rgba": "rgba(79, 188, 107, 1)",
        "hsl": "hsl(135, 45%, 52%)",
        "hsla": "hsl(135, 45%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Gauge OEE Excellent",
      "values": {
        "hex": "#30B0C7",
        "hexa": "#30B0C7ff",
        "rgb": "rgb(48, 176, 199)",
        "rgba": "rgba(48, 176, 199, 1)",
        "hsl": "hsl(189, 61%, 48%)",
        "hsla": "hsl(189, 61%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Gauge OEE World Class",
      "values": {
        "hex": "#5856D6",
        "hexa": "#5856D6ff",
        "rgb": "rgb(88, 86, 214)",
        "rgba": "rgba(88, 86, 214, 1)",
        "hsl": "hsl(241, 60%, 59%)",
        "hsla": "hsl(241, 60%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Light/Gauge Pieces",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Productive Tile",
      "values": {
        "hex": "#212121",
        "hexa": "#212121ff",
        "rgb": "rgb(33, 33, 33)",
        "rgba": "rgba(33, 33, 33, 1)",
        "hsl": "hsl(0, 0%, 13%)",
        "hsla": "hsl(0, 0%, 13%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Active",
      "values": {
        "hex": "#156228",
        "hexa": "#156228ff",
        "rgb": "rgb(21, 98, 40)",
        "rgba": "rgba(21, 98, 40, 1)",
        "hsl": "hsl(135, 65%, 23%)",
        "hsla": "hsl(135, 65%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Active hatch",
      "values": {
        "hex": "#40784E",
        "hexa": "#40784Eff",
        "rgb": "rgb(64, 120, 78)",
        "rgba": "rgba(64, 120, 78, 1)",
        "hsl": "hsl(135, 30%, 36%)",
        "hsla": "hsl(135, 30%, 36%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Change",
      "values": {
        "hex": "#BF5B00",
        "hexa": "#BF5B00ff",
        "rgb": "rgb(191, 91, 0)",
        "rgba": "rgba(191, 91, 0, 1)",
        "hsl": "hsl(29, 100%, 37%)",
        "hsla": "hsl(29, 100%, 37%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Change hatch",
      "values": {
        "hex": "#BF5B00",
        "hexa": "#BF5B00ff",
        "rgb": "rgb(191, 91, 0)",
        "rgba": "rgba(191, 91, 0, 1)",
        "hsl": "hsl(29, 100%, 37%)",
        "hsla": "hsl(29, 100%, 37%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Setup",
      "values": {
        "hex": "#5E156B",
        "hexa": "#5E156Bff",
        "rgb": "rgb(94, 21, 107)",
        "rgba": "rgba(94, 21, 107, 1)",
        "hsl": "hsl(291, 67%, 25%)",
        "hsla": "hsl(291, 67%, 25%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Setup hatch",
      "values": {
        "hex": "#5E156B",
        "hexa": "#5E156Bff",
        "rgb": "rgb(94, 21, 107)",
        "rgba": "rgba(94, 21, 107, 1)",
        "hsl": "hsl(291, 67%, 25%)",
        "hsla": "hsl(291, 67%, 25%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Not Productive",
      "values": {
        "hex": "#303030",
        "hexa": "#303030ff",
        "rgb": "rgb(48, 48, 48)",
        "rgba": "rgba(48, 48, 48, 1)",
        "hsl": "hsl(0, 0%, 19%)",
        "hsla": "hsl(0, 0%, 19%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Not Productive hatch",
      "values": {
        "hex": "#303030",
        "hexa": "#303030ff",
        "rgb": "rgb(48, 48, 48)",
        "rgba": "rgba(48, 48, 48, 1)",
        "hsl": "hsl(0, 0%, 19%)",
        "hsla": "hsl(0, 0%, 19%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Not Productive Tile",
      "values": {
        "hex": "#1B1B1B",
        "hexa": "#1B1B1Bff",
        "rgb": "rgb(27, 27, 27)",
        "rgba": "rgba(27, 27, 27, 1)",
        "hsl": "hsl(0, 0%, 11%)",
        "hsla": "hsl(0, 0%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Tile Hairline",
      "values": {
        "hex": "#6B6B6B",
        "hexa": "#6B6B6B1a",
        "rgb": "rgb(107, 107, 107)",
        "rgba": "rgba(107, 107, 107, 0.1)",
        "hsl": "hsl(0, 0%, 42%)",
        "hsla": "hsl(0, 0%, 42%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Wallboard/Dark/Gauge OEE Poor",
      "values": {
        "hex": "#E85344",
        "hexa": "#E85344ff",
        "rgb": "rgb(232, 83, 68)",
        "rgba": "rgba(232, 83, 68, 1)",
        "hsl": "hsl(5, 78%, 59%)",
        "hsla": "hsl(5, 78%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Gauge OEE Fair",
      "values": {
        "hex": "#BF5B00",
        "hexa": "#BF5B00ff",
        "rgb": "rgb(191, 91, 0)",
        "rgba": "rgba(191, 91, 0, 1)",
        "hsl": "hsl(29, 100%, 37%)",
        "hsla": "hsl(29, 100%, 37%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Gauge OEE Good",
      "values": {
        "hex": "#69A577",
        "hexa": "#69A577ff",
        "rgb": "rgb(105, 165, 119)",
        "rgba": "rgba(105, 165, 119, 1)",
        "hsl": "hsl(134, 25%, 53%)",
        "hsla": "hsl(134, 25%, 53%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Gauge OEE Excellent",
      "values": {
        "hex": "#40C8E0",
        "hexa": "#40C8E0ff",
        "rgb": "rgb(64, 200, 224)",
        "rgba": "rgba(64, 200, 224, 1)",
        "hsl": "hsl(189, 72%, 56%)",
        "hsla": "hsl(189, 72%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Gauge OEE World Class",
      "values": {
        "hex": "#5E5CE6",
        "hexa": "#5E5CE6ff",
        "rgb": "rgb(94, 92, 230)",
        "rgba": "rgba(94, 92, 230, 1)",
        "hsl": "hsl(241, 73%, 63%)",
        "hsla": "hsl(241, 73%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Gauge Pieces",
      "values": {
        "hex": "#959493",
        "hexa": "#959493ff",
        "rgb": "rgb(149, 148, 147)",
        "rgba": "rgba(149, 148, 147, 1)",
        "hsl": "hsl(30, 1%, 58%)",
        "hsla": "hsl(30, 1%, 58%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Wallboard/Dark/Touch/Light",
      "values": {
        "hex": "#F9F9FA",
        "hexa": "#F9F9FA0",
        "rgb": "rgb(249, 249, 250)",
        "rgba": "rgba(249, 249, 250, 0)",
        "hsl": "hsl(240, 9%, 98%)",
        "hsla": "hsl(240, 9%, 98%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Wallboard/Dark/Touch/Dark",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1E0",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 0)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Special/Light/Chevron",
      "values": {
        "hex": "#C4C4C6",
        "hexa": "#C4C4C6ff",
        "rgb": "rgb(196, 196, 198)",
        "rgba": "rgba(196, 196, 198, 1)",
        "hsl": "hsl(240, 2%, 77%)",
        "hsla": "hsl(240, 2%, 77%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Special/Light/Cursor",
      "values": {
        "hex": "#738BEA",
        "hexa": "#738BEAff",
        "rgb": "rgb(115, 139, 234)",
        "rgba": "rgba(115, 139, 234, 1)",
        "hsl": "hsl(228, 74%, 68%)",
        "hsla": "hsl(228, 74%, 68%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Special/Dark/Chevron",
      "values": {
        "hex": "#57575A",
        "hexa": "#57575Aff",
        "rgb": "rgb(87, 87, 90)",
        "rgba": "rgba(87, 87, 90, 1)",
        "hsl": "hsl(240, 2%, 35%)",
        "hsla": "hsl(240, 2%, 35%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Special/Dark/Cursor",
      "values": {
        "hex": "#4C6AEA",
        "hexa": "#4C6AEAff",
        "rgb": "rgb(76, 106, 234)",
        "rgba": "rgba(76, 106, 234, 1)",
        "hsl": "hsl(229, 79%, 61%)",
        "hsla": "hsl(229, 79%, 61%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Red",
      "values": {
        "hex": "#FF3B30",
        "hexa": "#FF3B30ff",
        "rgb": "rgb(255, 59, 48)",
        "rgba": "rgba(255, 59, 48, 1)",
        "hsl": "hsl(3, 100%, 59%)",
        "hsla": "hsl(3, 100%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Orange",
      "values": {
        "hex": "#FF9500",
        "hexa": "#FF9500ff",
        "rgb": "rgb(255, 149, 0)",
        "rgba": "rgba(255, 149, 0, 1)",
        "hsl": "hsl(35, 100%, 50%)",
        "hsla": "hsl(35, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Yellow",
      "values": {
        "hex": "#FFCC00",
        "hexa": "#FFCC00ff",
        "rgb": "rgb(255, 204, 0)",
        "rgba": "rgba(255, 204, 0, 1)",
        "hsl": "hsl(48, 100%, 50%)",
        "hsla": "hsl(48, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Green",
      "values": {
        "hex": "#34C759",
        "hexa": "#34C759ff",
        "rgb": "rgb(52, 199, 89)",
        "rgba": "rgba(52, 199, 89, 1)",
        "hsl": "hsl(135, 59%, 49%)",
        "hsla": "hsl(135, 59%, 49%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Mint",
      "values": {
        "hex": "#00C7BE",
        "hexa": "#00C7BEff",
        "rgb": "rgb(0, 199, 190)",
        "rgba": "rgba(0, 199, 190, 1)",
        "hsl": "hsl(177, 100%, 39%)",
        "hsla": "hsl(177, 100%, 39%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Teal",
      "values": {
        "hex": "#30B0C7",
        "hexa": "#30B0C7ff",
        "rgb": "rgb(48, 176, 199)",
        "rgba": "rgba(48, 176, 199, 1)",
        "hsl": "hsl(189, 61%, 48%)",
        "hsla": "hsl(189, 61%, 48%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Cyan",
      "values": {
        "hex": "#32ADE6",
        "hexa": "#32ADE6ff",
        "rgb": "rgb(50, 173, 230)",
        "rgba": "rgba(50, 173, 230, 1)",
        "hsl": "hsl(199, 78%, 55%)",
        "hsla": "hsl(199, 78%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Blue",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Indigo",
      "values": {
        "hex": "#5856D6",
        "hexa": "#5856D6ff",
        "rgb": "rgb(88, 86, 214)",
        "rgba": "rgba(88, 86, 214, 1)",
        "hsl": "hsl(241, 61%, 59%)",
        "hsla": "hsl(241, 61%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Purple",
      "values": {
        "hex": "#AF52DE",
        "hexa": "#AF52DEff",
        "rgb": "rgb(175, 82, 222)",
        "rgba": "rgba(175, 82, 222, 1)",
        "hsl": "hsl(280, 68%, 60%)",
        "hsla": "hsl(280, 68%, 60%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Pink",
      "values": {
        "hex": "#FF2D55",
        "hexa": "#FF2D55ff",
        "rgb": "rgb(255, 45, 85)",
        "rgba": "rgba(255, 45, 85, 1)",
        "hsl": "hsl(349, 100%, 59%)",
        "hsla": "hsl(349, 100%, 59%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Brown",
      "values": {
        "hex": "#A2845E",
        "hexa": "#A2845Eff",
        "rgb": "rgb(162, 132, 94)",
        "rgba": "rgba(162, 132, 94, 1)",
        "hsl": "hsl(34, 27%, 50%)",
        "hsla": "hsl(34, 27%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Light/Red50%",
      "values": {
        "hex": "#FF3B30",
        "hexa": "#FF3B3080",
        "rgb": "rgb(255, 59, 48)",
        "rgba": "rgba(255, 59, 48, 0.5)",
        "hsl": "hsl(3, 100%, 59%)",
        "hsla": "hsl(3, 100%, 59%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "System/Light/Transparant",
      "values": {
        "hex": "#000000",
        "hexa": "#0000000",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "System/Dark/Red",
      "values": {
        "hex": "#FF453A",
        "hexa": "#FF453Aff",
        "rgb": "rgb(255, 69, 58)",
        "rgba": "rgba(255, 69, 58, 1)",
        "hsl": "hsl(3, 100%, 61%)",
        "hsla": "hsl(3, 100%, 61%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Orange",
      "values": {
        "hex": "#FF9F0A",
        "hexa": "#FF9F0Aff",
        "rgb": "rgb(255, 159, 10)",
        "rgba": "rgba(255, 159, 10, 1)",
        "hsl": "hsl(36, 100%, 52%)",
        "hsla": "hsl(36, 100%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Yellow",
      "values": {
        "hex": "#FFD60A",
        "hexa": "#FFD60Aff",
        "rgb": "rgb(255, 214, 10)",
        "rgba": "rgba(255, 214, 10, 1)",
        "hsl": "hsl(50, 100%, 52%)",
        "hsla": "hsl(50, 100%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Green",
      "values": {
        "hex": "#32D74B",
        "hexa": "#32D74Bff",
        "rgb": "rgb(50, 215, 75)",
        "rgba": "rgba(50, 215, 75, 1)",
        "hsl": "hsl(129, 67%, 52%)",
        "hsla": "hsl(129, 67%, 52%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Mint",
      "values": {
        "hex": "#63E6E2",
        "hexa": "#63E6E2ff",
        "rgb": "rgb(99, 230, 226)",
        "rgba": "rgba(99, 230, 226, 1)",
        "hsl": "hsl(178, 72%, 65%)",
        "hsla": "hsl(178, 72%, 65%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Teal",
      "values": {
        "hex": "#40C8E0",
        "hexa": "#40C8E0ff",
        "rgb": "rgb(64, 200, 224)",
        "rgba": "rgba(64, 200, 224, 1)",
        "hsl": "hsl(189, 72%, 56%)",
        "hsla": "hsl(189, 72%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Cyan",
      "values": {
        "hex": "#64D2FF",
        "hexa": "#64D2FFff",
        "rgb": "rgb(100, 210, 255)",
        "rgba": "rgba(100, 210, 255, 1)",
        "hsl": "hsl(197, 100%, 70%)",
        "hsla": "hsl(197, 100%, 70%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Blue",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Indigo",
      "values": {
        "hex": "#5E5CE6",
        "hexa": "#5E5CE6ff",
        "rgb": "rgb(94, 92, 230)",
        "rgba": "rgba(94, 92, 230, 1)",
        "hsl": "hsl(241, 73%, 63%)",
        "hsla": "hsl(241, 73%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Purple",
      "values": {
        "hex": "#BF5AF2",
        "hexa": "#BF5AF2ff",
        "rgb": "rgb(191, 90, 242)",
        "rgba": "rgba(191, 90, 242, 1)",
        "hsl": "hsl(280, 85%, 65%)",
        "hsla": "hsl(280, 85%, 65%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Pink",
      "values": {
        "hex": "#FF375F",
        "hexa": "#FF375Fff",
        "rgb": "rgb(255, 55, 95)",
        "rgba": "rgba(255, 55, 95, 1)",
        "hsl": "hsl(348, 100%, 61%)",
        "hsla": "hsl(348, 100%, 61%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Brown",
      "values": {
        "hex": "#AC8E68",
        "hexa": "#AC8E68ff",
        "rgb": "rgb(172, 142, 104)",
        "rgba": "rgba(172, 142, 104, 1)",
        "hsl": "hsl(34, 29%, 54%)",
        "hsla": "hsl(34, 29%, 54%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "System/Dark/Red50%",
      "values": {
        "hex": "#FF453A",
        "hexa": "#FF453A80",
        "rgb": "rgb(255, 69, 58)",
        "rgba": "rgba(255, 69, 58, 0.5)",
        "hsl": "hsl(3, 100%, 61%)",
        "hsla": "hsl(3, 100%, 61%, 0.5)",
        "alpha": 0.5
      }
    },
    {
      "name": "System/Dark/Transparant",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF0",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0)",
        "alpha": 0
      }
    },
    {
      "name": "Picture/Light/Overlay",
      "values": {
        "hex": "#000000",
        "hexa": "#0000008",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.03)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.03)",
        "alpha": 0.03
      }
    },
    {
      "name": "Picture/Light/Underlay",
      "values": {
        "hex": "#F0F0F0",
        "hexa": "#F0F0F01a",
        "rgb": "rgb(240, 240, 240)",
        "rgba": "rgba(240, 240, 240, 0.1)",
        "hsl": "hsl(0, 0%, 94%)",
        "hsla": "hsl(0, 0%, 94%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Picture/Light/Underlay Selected",
      "values": {
        "hex": "#000000",
        "hexa": "#00000012",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.07)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.07)",
        "alpha": 0.07
      }
    },
    {
      "name": "Picture/Light/Button Background",
      "values": {
        "hex": "#000000",
        "hexa": "#0000001a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "Picture/Dark/Overlay",
      "values": {
        "hex": "#000000",
        "hexa": "#0000004d",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.3)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.3)",
        "alpha": 0.3
      }
    },
    {
      "name": "Picture/Dark/Underlay",
      "values": {
        "hex": "#2E2D2B",
        "hexa": "#2E2D2Bff",
        "rgb": "rgb(46, 45, 43)",
        "rgba": "rgba(46, 45, 43, 1)",
        "hsl": "hsl(40, 3%, 17%)",
        "hsla": "hsl(40, 3%, 17%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Picture/Dark/Underlay Selected",
      "values": {
        "hex": "#29609C",
        "hexa": "#29609C3",
        "rgb": "rgb(41, 96, 156)",
        "rgba": "rgba(41, 96, 156, 0.01)",
        "hsl": "hsl(211, 58%, 39%)",
        "hsla": "hsl(211, 58%, 39%, 0.01)",
        "alpha": 0.01
      }
    },
    {
      "name": "Picture/Dark/Button Background",
      "values": {
        "hex": "#000000",
        "hexa": "#0000001a",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 0.1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 0.1)",
        "alpha": 0.1
      }
    },
    {
      "name": "NC-Color/Light/Default",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Light/Line number",
      "values": {
        "hex": "#BF3CC9",
        "hexa": "#BF3CC9ff",
        "rgb": "rgb(191, 60, 201)",
        "rgba": "rgba(191, 60, 201, 1)",
        "hsl": "hsl(296, 57%, 51%)",
        "hsla": "hsl(296, 57%, 51%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Light/Value",
      "values": {
        "hex": "#0000C0",
        "hexa": "#0000C0ff",
        "rgb": "rgb(0, 0, 192)",
        "rgba": "rgba(0, 0, 192, 1)",
        "hsl": "hsl(240, 100%, 38%)",
        "hsla": "hsl(240, 100%, 38%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Light/FMAX",
      "values": {
        "hex": "#CA5656",
        "hexa": "#CA5656ff",
        "rgb": "rgb(202, 86, 86)",
        "rgba": "rgba(202, 86, 86, 1)",
        "hsl": "hsl(0, 52%, 56%)",
        "hsla": "hsl(0, 52%, 56%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Light/Comment",
      "values": {
        "hex": "#377E22",
        "hexa": "#377E22ff",
        "rgb": "rgb(55, 126, 34)",
        "rgba": "rgba(55, 126, 34, 1)",
        "hsl": "hsl(106, 58%, 31%)",
        "hsla": "hsl(106, 58%, 31%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Dark/Default",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Dark/Line number",
      "values": {
        "hex": "#E870F1",
        "hexa": "#E870F1ff",
        "rgb": "rgb(232, 112, 241)",
        "rgba": "rgba(232, 112, 241, 1)",
        "hsl": "hsl(296, 82%, 69%)",
        "hsla": "hsl(296, 82%, 69%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Dark/Value",
      "values": {
        "hex": "#9797FF",
        "hexa": "#9797FFff",
        "rgb": "rgb(151, 151, 255)",
        "rgba": "rgba(151, 151, 255, 1)",
        "hsl": "hsl(240, 100%, 80%)",
        "hsla": "hsl(240, 100%, 80%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Dark/FMAX",
      "values": {
        "hex": "#EC9271",
        "hexa": "#EC9271ff",
        "rgb": "rgb(236, 146, 113)",
        "rgba": "rgba(236, 146, 113, 1)",
        "hsl": "hsl(16, 76%, 68%)",
        "hsla": "hsl(16, 76%, 68%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC-Color/Dark/Comment",
      "values": {
        "hex": "#64B94B",
        "hexa": "#64B94Bff",
        "rgb": "rgb(100, 185, 75)",
        "rgba": "rgba(100, 185, 75, 1)",
        "hsl": "hsl(106, 44%, 51%)",
        "hsla": "hsl(106, 44%, 51%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Shadow/Dark/Ultra Wide",
      "values": {
        "hex": "#4F4F50",
        "hexa": "#4F4F50ff",
        "rgb": "rgb(79, 79, 80)",
        "rgba": "rgba(79, 79, 80, 1)",
        "hsl": "hsl(240, 1%, 31%)",
        "hsla": "hsl(240, 1%, 31%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Shadow/Dark/Bottom Sheet",
      "values": {
        "hex": "#4F4F50",
        "hexa": "#4F4F50ff",
        "rgb": "rgb(79, 79, 80)",
        "rgba": "rgba(79, 79, 80, 1)",
        "hsl": "hsl(240, 1%, 31%)",
        "hsla": "hsl(240, 1%, 31%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Light/1 Missing Production Information",
      "values": {
        "hex": "#FAEFAF",
        "hexa": "#FAEFAFff",
        "rgb": "rgb(250, 239, 175)",
        "rgba": "rgba(250, 239, 175, 1)",
        "hsl": "hsl(51, 88%, 83%)",
        "hsla": "hsl(51, 88%, 83%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Light/2 Missing Production Information",
      "values": {
        "hex": "#FDF6CA",
        "hexa": "#FDF6CAff",
        "rgb": "rgb(253, 246, 202)",
        "rgba": "rgba(253, 246, 202, 1)",
        "hsl": "hsl(52, 93%, 89%)",
        "hsla": "hsl(52, 93%, 89%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Light/3 Missing Production Information",
      "values": {
        "hex": "#312A00",
        "hexa": "#312A00ff",
        "rgb": "rgb(49, 42, 0)",
        "rgba": "rgba(49, 42, 0, 1)",
        "hsl": "hsl(51, 100%, 10%)",
        "hsla": "hsl(51, 100%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Light/4 Missing Production Information",
      "values": {
        "hex": "#E8CC29",
        "hexa": "#E8CC29ff",
        "rgb": "rgb(232, 204, 41)",
        "rgba": "rgba(232, 204, 41, 1)",
        "hsl": "hsl(51, 81%, 54%)",
        "hsla": "hsl(51, 81%, 54%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Light/Error 1",
      "values": {
        "hex": "#F9EFED",
        "hexa": "#F9EFEDff",
        "rgb": "rgb(249, 239, 237)",
        "rgba": "rgba(249, 239, 237, 1)",
        "hsl": "hsl(10, 50%, 95%)",
        "hsla": "hsl(10, 50%, 95%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Light/Error 2",
      "values": {
        "hex": "#FFAFA5",
        "hexa": "#FFAFA5ff",
        "rgb": "rgb(255, 175, 165)",
        "rgba": "rgba(255, 175, 165, 1)",
        "hsl": "hsl(7, 100%, 82%)",
        "hsla": "hsl(7, 100%, 82%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Dark/1 Missing Production Information",
      "values": {
        "hex": "#352D00",
        "hexa": "#352D00ff",
        "rgb": "rgb(53, 45, 0)",
        "rgba": "rgba(53, 45, 0, 1)",
        "hsl": "hsl(51, 100%, 10%)",
        "hsla": "hsl(51, 100%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Dark/2 Missing Production Information",
      "values": {
        "hex": "#25231D",
        "hexa": "#25231Dff",
        "rgb": "rgb(37, 35, 29)",
        "rgba": "rgba(37, 35, 29, 1)",
        "hsl": "hsl(45, 12%, 13%)",
        "hsla": "hsl(45, 12%, 13%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Dark/3 Missing Production Information",
      "values": {
        "hex": "#312A00",
        "hexa": "#312A00ff",
        "rgb": "rgb(49, 42, 0)",
        "rgba": "rgba(49, 42, 0, 1)",
        "hsl": "hsl(51, 100%, 10%)",
        "hsla": "hsl(51, 100%, 10%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Dark/4 Missing Production Information",
      "values": {
        "hex": "#DDBA00",
        "hexa": "#DDBA00ff",
        "rgb": "rgb(221, 186, 0)",
        "rgba": "rgba(221, 186, 0, 1)",
        "hsl": "hsl(50, 100%, 43%)",
        "hsla": "hsl(50, 100%, 43%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Dark/Error 1",
      "values": {
        "hex": "#351D1B",
        "hexa": "#351D1Bff",
        "rgb": "rgb(53, 29, 27)",
        "rgba": "rgba(53, 29, 27, 1)",
        "hsl": "hsl(5, 33%, 16%)",
        "hsla": "hsl(5, 33%, 16%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Hatch/Dark/Error 2",
      "values": {
        "hex": "#B15347",
        "hexa": "#B15347ff",
        "rgb": "rgb(177, 83, 71)",
        "rgba": "rgba(177, 83, 71, 1)",
        "hsl": "hsl(7, 43%, 49%)",
        "hsla": "hsl(7, 43%, 49%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Light/Base",
      "values": {
        "hex": "#F1F1F8",
        "hexa": "#F1F1F8ff",
        "rgb": "rgb(241, 241, 248)",
        "rgba": "rgba(241, 241, 248, 1)",
        "hsl": "hsl(240, 33%, 96%)",
        "hsla": "hsl(240, 33%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Light/Base Weekend",
      "values": {
        "hex": "#F7F7FE",
        "hexa": "#F7F7FEff",
        "rgb": "rgb(247, 247, 254)",
        "rgba": "rgba(247, 247, 254, 1)",
        "hsl": "hsl(240, 78%, 98%)",
        "hsla": "hsl(240, 78%, 98%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Light/Ahead",
      "values": {
        "hex": "#92D785",
        "hexa": "#92D785ff",
        "rgb": "rgb(146, 215, 133)",
        "rgba": "rgba(146, 215, 133, 1)",
        "hsl": "hsl(110, 51%, 68%)",
        "hsla": "hsl(110, 51%, 68%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Light/Ahead Weekend",
      "values": {
        "hex": "#B8F0B0",
        "hexa": "#B8F0B0ff",
        "rgb": "rgb(184, 240, 176)",
        "rgba": "rgba(184, 240, 176, 1)",
        "hsl": "hsl(113, 68%, 82%)",
        "hsla": "hsl(113, 68%, 82%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Light/Late",
      "values": {
        "hex": "#FC9B9B",
        "hexa": "#FC9B9Bff",
        "rgb": "rgb(252, 155, 155)",
        "rgba": "rgba(252, 155, 155, 1)",
        "hsl": "hsl(0, 94%, 80%)",
        "hsla": "hsl(0, 94%, 80%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Light/Late Weekend",
      "values": {
        "hex": "#FED3CE",
        "hexa": "#FED3CEff",
        "rgb": "rgb(254, 211, 206)",
        "rgba": "rgba(254, 211, 206, 1)",
        "hsl": "hsl(6, 96%, 90%)",
        "hsla": "hsl(6, 96%, 90%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Light/Stroke",
      "values": {
        "hex": "#C7C7CC",
        "hexa": "#C7C7CCff",
        "rgb": "rgb(199, 199, 204)",
        "rgba": "rgba(199, 199, 204, 1)",
        "hsl": "hsl(240, 5%, 79%)",
        "hsla": "hsl(240, 5%, 79%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Dark/Base",
      "values": {
        "hex": "#3F3F46",
        "hexa": "#3F3F46ff",
        "rgb": "rgb(63, 63, 70)",
        "rgba": "rgba(63, 63, 70, 1)",
        "hsl": "hsl(240, 5%, 26%)",
        "hsla": "hsl(240, 5%, 26%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Dark/Base Weekend",
      "values": {
        "hex": "#36363C",
        "hexa": "#36363Cff",
        "rgb": "rgb(54, 54, 60)",
        "rgba": "rgba(54, 54, 60, 1)",
        "hsl": "hsl(240, 5%, 22%)",
        "hsla": "hsl(240, 5%, 22%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Dark/Ahead Weekend",
      "values": {
        "hex": "#345A2E",
        "hexa": "#345A2Eff",
        "rgb": "rgb(52, 90, 46)",
        "rgba": "rgba(52, 90, 46, 1)",
        "hsl": "hsl(112, 32%, 27%)",
        "hsla": "hsl(112, 32%, 27%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Dark/Ahead",
      "values": {
        "hex": "#3E7933",
        "hexa": "#3E7933ff",
        "rgb": "rgb(62, 121, 51)",
        "rgba": "rgba(62, 121, 51, 1)",
        "hsl": "hsl(111, 41%, 34%)",
        "hsla": "hsl(111, 41%, 34%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Dark/Late Weekend",
      "values": {
        "hex": "#672D28",
        "hexa": "#672D28ff",
        "rgb": "rgb(103, 45, 40)",
        "rgba": "rgba(103, 45, 40, 1)",
        "hsl": "hsl(5, 44%, 28%)",
        "hsla": "hsl(5, 44%, 28%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Dark/Late",
      "values": {
        "hex": "#813B34",
        "hexa": "#813B34ff",
        "rgb": "rgb(129, 59, 52)",
        "rgba": "rgba(129, 59, 52, 1)",
        "hsl": "hsl(5, 43%, 35%)",
        "hsla": "hsl(5, 43%, 35%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Day/Dark/Stroke",
      "values": {
        "hex": "#787878",
        "hexa": "#787878ff",
        "rgb": "rgb(120, 120, 120)",
        "rgba": "rgba(120, 120, 120, 1)",
        "hsl": "hsl(0, 0%, 47%)",
        "hsla": "hsl(0, 0%, 47%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Light/Actual",
      "values": {
        "hex": "#007AFF",
        "hexa": "#007AFFff",
        "rgb": "rgb(0, 122, 255)",
        "rgba": "rgba(0, 122, 255, 1)",
        "hsl": "hsl(211, 100%, 50%)",
        "hsla": "hsl(211, 100%, 50%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Light/Paid",
      "values": {
        "hex": "#3634A3",
        "hexa": "#3634A3ff",
        "rgb": "rgb(54, 52, 163)",
        "rgba": "rgba(54, 52, 163, 1)",
        "hsl": "hsl(241, 52%, 42%)",
        "hsla": "hsl(241, 52%, 42%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Light/Scheduled",
      "values": {
        "hex": "#32ADE6",
        "hexa": "#32ADE6ff",
        "rgb": "rgb(50, 173, 230)",
        "rgba": "rgba(50, 173, 230, 1)",
        "hsl": "hsl(199, 78%, 55%)",
        "hsla": "hsl(199, 78%, 55%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Light/Ideal",
      "values": {
        "hex": "#87878B",
        "hexa": "#87878Bff",
        "rgb": "rgb(135, 135, 139)",
        "rgba": "rgba(135, 135, 139, 1)",
        "hsl": "hsl(240, 2%, 54%)",
        "hsla": "hsl(240, 2%, 54%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Dark/Actual",
      "values": {
        "hex": "#4791F8",
        "hexa": "#4791F8ff",
        "rgb": "rgb(71, 145, 248)",
        "rgba": "rgba(71, 145, 248, 1)",
        "hsl": "hsl(215, 93%, 63%)",
        "hsla": "hsl(215, 93%, 63%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Dark/Paid",
      "values": {
        "hex": "#7D7AFF",
        "hexa": "#7D7AFFff",
        "rgb": "rgb(125, 122, 255)",
        "rgba": "rgba(125, 122, 255, 1)",
        "hsl": "hsl(241, 100%, 74%)",
        "hsla": "hsl(241, 100%, 74%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Dark/Scheduled",
      "values": {
        "hex": "#64D2FF",
        "hexa": "#64D2FFff",
        "rgb": "rgb(100, 210, 255)",
        "rgba": "rgba(100, 210, 255, 1)",
        "hsl": "hsl(197, 100%, 70%)",
        "hsla": "hsl(197, 100%, 70%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Time/Dark/Ideal",
      "values": {
        "hex": "#9B9A9C",
        "hexa": "#9B9A9Cff",
        "rgb": "rgb(155, 154, 156)",
        "rgba": "rgba(155, 154, 156, 1)",
        "hsl": "hsl(270, 1%, 61%)",
        "hsla": "hsl(270, 1%, 61%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Light/Selected Background",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Light/Hover Background",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFF66",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.4)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.4)",
        "alpha": 0.4
      }
    },
    {
      "name": "Segmented/Light/Selected Text",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Light/Hover Text",
      "values": {
        "hex": "#000000",
        "hexa": "#000000ff",
        "rgb": "rgb(0, 0, 0)",
        "rgba": "rgba(0, 0, 0, 1)",
        "hsl": "hsl(0, 0%, 0%)",
        "hsla": "hsl(0, 0%, 0%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Light/Unselected Text",
      "values": {
        "hex": "#404045",
        "hexa": "#404045ff",
        "rgb": "rgb(64, 64, 69)",
        "rgba": "rgba(64, 64, 69, 1)",
        "hsl": "hsl(240, 4%, 26%)",
        "hsla": "hsl(240, 4%, 26%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Dark/Selected Background",
      "values": {
        "hex": "#5A5A5F",
        "hexa": "#5A5A5Fff",
        "rgb": "rgb(90, 90, 95)",
        "rgba": "rgba(90, 90, 95, 1)",
        "hsl": "hsl(240, 3%, 36%)",
        "hsla": "hsl(240, 3%, 36%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Dark/Hover Background",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFf",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 0.06)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 0.06)",
        "alpha": 0.06
      }
    },
    {
      "name": "Segmented/Dark/Selected Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Dark/Hover Text",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Segmented/Dark/Unselected Text",
      "values": {
        "hex": "#B4B4B4",
        "hexa": "#B4B4B4ff",
        "rgb": "rgb(180, 180, 180)",
        "rgba": "rgba(180, 180, 180, 1)",
        "hsl": "hsl(0, 0%, 71%)",
        "hsla": "hsl(0, 0%, 71%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray Always/Light/5",
      "values": {
        "hex": "#EDEDED",
        "hexa": "#EDEDEDff",
        "rgb": "rgb(237, 237, 237)",
        "rgba": "rgba(237, 237, 237, 1)",
        "hsl": "hsl(0, 0%, 93%)",
        "hsla": "hsl(0, 0%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "Gray Always/Dark/5",
      "values": {
        "hex": "#EDEDED",
        "hexa": "#EDEDEDff",
        "rgb": "rgb(237, 237, 237)",
        "rgba": "rgba(237, 237, 237, 1)",
        "hsl": "hsl(0, 0%, 93%)",
        "hsla": "hsl(0, 0%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Light/Background",
      "values": {
        "hex": "#FFFFFF",
        "hexa": "#FFFFFFff",
        "rgb": "rgb(255, 255, 255)",
        "rgba": "rgba(255, 255, 255, 1)",
        "hsl": "hsl(0, 0%, 100%)",
        "hsla": "hsl(0, 0%, 100%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Light/Placeholder",
      "values": {
        "hex": "#F4F4F5",
        "hexa": "#F4F4F5ff",
        "rgb": "rgb(244, 244, 245)",
        "rgba": "rgba(244, 244, 245, 1)",
        "hsl": "hsl(240, 5%, 96%)",
        "hsla": "hsl(240, 5%, 96%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Light/Marked Section Left",
      "values": {
        "hex": "#FFE2E2",
        "hexa": "#FFE2E2ff",
        "rgb": "rgb(255, 226, 226)",
        "rgba": "rgba(255, 226, 226, 1)",
        "hsl": "hsl(0, 100%, 94%)",
        "hsla": "hsl(0, 100%, 94%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Light/Marked Section Right",
      "values": {
        "hex": "#DBFFDB",
        "hexa": "#DBFFDBff",
        "rgb": "rgb(219, 255, 219)",
        "rgba": "rgba(219, 255, 219, 1)",
        "hsl": "hsl(120, 100%, 93%)",
        "hsla": "hsl(120, 100%, 93%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Light/Marked Character Left",
      "values": {
        "hex": "#FFC5C5",
        "hexa": "#FFC5C5ff",
        "rgb": "rgb(255, 197, 197)",
        "rgba": "rgba(255, 197, 197, 1)",
        "hsl": "hsl(0, 100%, 89%)",
        "hsla": "hsl(0, 100%, 89%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Light/Marked Character Right",
      "values": {
        "hex": "#B6EAB6",
        "hexa": "#B6EAB6ff",
        "rgb": "rgb(182, 234, 182)",
        "rgba": "rgba(182, 234, 182, 1)",
        "hsl": "hsl(120, 55%, 82%)",
        "hsla": "hsl(120, 55%, 82%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Dark/Background",
      "values": {
        "hex": "#1C1C1E",
        "hexa": "#1C1C1Eff",
        "rgb": "rgb(28, 28, 30)",
        "rgba": "rgba(28, 28, 30, 1)",
        "hsl": "hsl(240, 3%, 11%)",
        "hsla": "hsl(240, 3%, 11%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Dark/Placeholder",
      "values": {
        "hex": "#2C2C2E",
        "hexa": "#2C2C2Eff",
        "rgb": "rgb(44, 44, 46)",
        "rgba": "rgba(44, 44, 46, 1)",
        "hsl": "hsl(240, 2%, 18%)",
        "hsla": "hsl(240, 2%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Dark/Marked Section Left",
      "values": {
        "hex": "#52242B",
        "hexa": "#52242Bff",
        "rgb": "rgb(82, 36, 43)",
        "rgba": "rgba(82, 36, 43, 1)",
        "hsl": "hsl(351, 39%, 23%)",
        "hsla": "hsl(351, 39%, 23%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Dark/Marked Section Right",
      "values": {
        "hex": "#1B3F26",
        "hexa": "#1B3F26ff",
        "rgb": "rgb(27, 63, 38)",
        "rgba": "rgba(27, 63, 38, 1)",
        "hsl": "hsl(138, 40%, 18%)",
        "hsla": "hsl(138, 40%, 18%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Dark/Marked Character Left",
      "values": {
        "hex": "#875656",
        "hexa": "#875656ff",
        "rgb": "rgb(135, 86, 86)",
        "rgba": "rgba(135, 86, 86, 1)",
        "hsl": "hsl(0, 22%, 43%)",
        "hsla": "hsl(0, 22%, 43%, 1)",
        "alpha": 1
      }
    },
    {
      "name": "NC File Comparison/Dark/Marked Character Right",
      "values": {
        "hex": "#477E47",
        "hexa": "#477E47ff",
        "rgb": "rgb(71, 126, 71)",
        "rgba": "rgba(71, 126, 71, 1)",
        "hsl": "hsl(120, 28%, 39%)",
        "hsla": "hsl(120, 28%, 39%, 1)",
        "alpha": 1
      }
    }
  ]
}